export type BuildingType =
  | 'Hotel'
  | 'Apartemen'
  | 'Ruko'
  | 'Kantor'
  | 'Perumahan'
  | 'Perumahan Cluster'
  | 'Pasar'
  | 'Mall'
  | 'Rumah Sakit'
  | 'Sekolah'
  | 'Kampus'
  | 'Gudang'
  | 'Pabrik'
  | 'Rumah Ibadah'
  | 'Marketing Gallery'
  | 'Club House'
  | 'Infrastruktur'
  | 'Lainnya';

export interface Project {
  id: number;
  name: string;
  buildingType: BuildingType;
  location: string;
  year: number;
  status: 'Selesai' | 'Ongoing';
  workPackage: string;
  unitCount?: string;
  buildingArea?: string;
  floors?: string;
  description: string;
  image: string;
  images: string[];
  client: string;
  value: string;
  imagePosition?: string;
}

export const projects: Project[] = [
  // ─── 2010 ───
  {
    id: 1,
    name: 'Perumahan Tanah Teduh',
    buildingType: 'Perumahan',
    location: 'Jakarta Selatan',
    year: 2010,
    status: 'Selesai',
    workPackage: 'Struktur, Arsitektur dan MEP Tahap 1',
    description: 'Pembangunan hunian residensial berkualitas tinggi dengan sistem mekanikal, elektrikal, dan plumbing terintegrasi di kawasan Tanah Teduh Jakarta Selatan.',
    image: 'https://readdy.ai/api/search-image?query=residential%20housing%20complex%20construction%20Jakarta%2C%20modern%20two%20story%20houses%20concrete%20structure%2C%20warm%20amber%20construction%20lighting%20dusk%2C%20dark%20dramatic%20sky%2C%20professional%20architectural%20photography%2C%20deep%20shadows%2C%20cinematic%20moody%20atmosphere%2C%20ultra%20realistic&width=800&height=600&seq=wmm-r1-2010&orientation=landscape',
    images: [
      'https://readdy.ai/api/search-image?query=residential%20housing%20complex%20construction%20Jakarta%2C%20modern%20two%20story%20houses%20concrete%20structure%2C%20warm%20amber%20construction%20lighting%20dusk%2C%20dark%20dramatic%20sky%2C%20professional%20architectural%20photography%2C%20deep%20shadows%2C%20cinematic%20moody%20atmosphere%2C%20ultra%20realistic&width=800&height=600&seq=wmm-r1-2010&orientation=landscape',
      'https://readdy.ai/api/search-image?query=residential%20housing%20interior%20construction%20MEP%20installation%20pipes%20electrical%20conduits%20concrete%20walls%2C%20warm%20work%20lights%2C%20dramatic%20shadows%2C%20industrial%20moody%20photography%2C%20cinematic&width=800&height=600&seq=wmm-r1b-2010&orientation=landscape',
    ],
    client: 'PT. Tasa Jati Padang',
    value: 'Rp 14.300.000.000,-',
  },
  {
    id: 2,
    name: 'Hotel Amaris Pekanbaru',
    buildingType: 'Hotel',
    location: 'Pekanbaru, Riau',
    year: 2010,
    status: 'Selesai',
    workPackage: 'Struktur dan Arsitektur',
    floors: '4 Lantai + 1 Basement',
    description: 'Pembangunan Hotel Amaris 4 lantai dengan 1 basement di Pekanbaru, mencakup pekerjaan struktur beton bertulang dan arsitektur eksterior-interior hotel bintang tiga modern.',
    image: 'https://readdy.ai/api/search-image?query=modern%20hotel%20building%20exterior%20night%20view%204%20floors%20basement%2C%20warm%20amber%20facade%20lighting%2C%20dark%20dramatic%20sky%2C%20concrete%20glass%20architecture%2C%20moody%20cinematic%20photography%2C%20deep%20shadows%2C%20ultra%20realistic&width=800&height=600&seq=wmm-r2-2010&orientation=landscape',
    images: [
      'https://readdy.ai/api/search-image?query=modern%20hotel%20building%20exterior%20night%20view%204%20floors%20basement%2C%20warm%20amber%20facade%20lighting%2C%20dark%20dramatic%20sky%2C%20concrete%20glass%20architecture%2C%20moody%20cinematic%20photography%2C%20deep%20shadows%2C%20ultra%20realistic&width=800&height=600&seq=wmm-r2-2010&orientation=landscape',
      'https://readdy.ai/api/search-image?query=hotel%20lobby%20interior%20dark%20sophisticated%20design%2C%20warm%20amber%20accent%20lighting%2C%20marble%20floor%2C%20dramatic%20shadows%2C%20moody%20cinematic%20photography%2C%20elegant%20atmosphere&width=800&height=600&seq=wmm-r2b-2010&orientation=landscape',
    ],
    client: 'PT. Graha Multi Utama',
    value: 'Rp 11.600.000.000,-',
  },
  {
    id: 3,
    name: 'Pasar Koja',
    buildingType: 'Pasar',
    location: 'Jakarta Utara',
    year: 2010,
    status: 'Selesai',
    workPackage: 'Struktur, Arsitektur dan MEP',
    floors: '2 Lantai',
    description: 'Pembangunan Pasar Koja 2 lantai di Jakarta Utara meliputi pekerjaan struktur, arsitektur, dan MEP lengkap untuk fasilitas pasar tradisional modern yang representatif.',
    image: 'https://readdy.ai/api/search-image?query=modern%20traditional%20market%20building%20two%20floors%20Jakarta%2C%20concrete%20structure%20warm%20amber%20lighting%20dusk%2C%20dark%20dramatic%20sky%2C%20commercial%20building%20architecture%2C%20moody%20cinematic%20photography%2C%20deep%20shadows%2C%20ultra%20realistic&width=800&height=600&seq=wmm-r3-2010&orientation=landscape',
    images: [
      'https://readdy.ai/api/search-image?query=modern%20traditional%20market%20building%20two%20floors%20Jakarta%2C%20concrete%20structure%20warm%20amber%20lighting%20dusk%2C%20dark%20dramatic%20sky%2C%20commercial%20building%20architecture%2C%20moody%20cinematic%20photography%2C%20deep%20shadows%2C%20ultra%20realistic&width=800&height=600&seq=wmm-r3-2010&orientation=landscape',
    ],
    client: 'PT. Bintang Anugrah Makmur',
    value: 'Rp 21.265.700.000,-',
  },
  {
    id: 4,
    name: 'Hotel Aston Palembang',
    buildingType: 'Hotel',
    location: 'Palembang, Sumatera Selatan',
    year: 2010,
    status: 'Selesai',
    workPackage: 'Struktur dan Arsitektur',
    floors: '10 Lantai',
    description: 'Pembangunan Hotel Aston 10 lantai di Palembang, mencakup pekerjaan struktur beton bertulang dan arsitektur eksterior-interior hotel bintang empat dengan desain modern dan elegan.',
    image: 'https://readdy.ai/api/search-image?query=tall%20hotel%20building%2010%20floors%20exterior%20night%20view%20Palembang%2C%20warm%20amber%20facade%20lighting%2C%20dark%20dramatic%20sky%2C%20modern%20concrete%20architecture%2C%20moody%20cinematic%20photography%2C%20deep%20shadows%2C%20ultra%20realistic&width=800&height=600&seq=wmm-r4-2010&orientation=landscape',
    images: [
      'https://readdy.ai/api/search-image?query=tall%20hotel%20building%2010%20floors%20exterior%20night%20view%20Palembang%2C%20warm%20amber%20facade%20lighting%2C%20dark%20dramatic%20sky%2C%20modern%20concrete%20architecture%2C%20moody%20cinematic%20photography%2C%20deep%20shadows%2C%20ultra%20realistic&width=800&height=600&seq=wmm-r4-2010&orientation=landscape',
    ],
    client: 'PT. Grand Central Hotel',
    value: 'Rp 29.461.000.000,-',
  },
  {
    id: 5,
    name: 'Gedung BCA KCU Rawamangun',
    buildingType: 'Kantor',
    location: 'Rawamangun, Jakarta Timur',
    year: 2010,
    status: 'Selesai',
    workPackage: 'Struktur dan Arsitektur',
    floors: '4 Lantai',
    description: 'Pembangunan Gedung BCA KCU Rawamangun 4 lantai mencakup pekerjaan struktur beton bertulang dan arsitektur eksterior-interior gedung perbankan modern yang representatif dan fungsional.',
    image: 'https://readdy.ai/api/search-image?query=modern%20bank%20office%20building%204%20floors%20exterior%20night%20view%20Jakarta%2C%20warm%20amber%20facade%20lighting%2C%20dark%20dramatic%20sky%2C%20corporate%20architecture%20glass%20concrete%2C%20moody%20cinematic%20photography%2C%20deep%20shadows%2C%20ultra%20realistic&width=800&height=600&seq=wmm-r5-2010&orientation=landscape',
    images: [
      'https://readdy.ai/api/search-image?query=modern%20bank%20office%20building%204%20floors%20exterior%20night%20view%20Jakarta%2C%20warm%20amber%20facade%20lighting%2C%20dark%20dramatic%20sky%2C%20corporate%20architecture%20glass%20concrete%2C%20moody%20cinematic%20photography%2C%20deep%20shadows%2C%20ultra%20realistic&width=800&height=600&seq=wmm-r5-2010&orientation=landscape',
    ],
    client: 'PT. BCA Tbk',
    value: 'Rp 8.430.000.000,-',
  },
  {
    id: 6,
    name: 'Hotel Amaris Bogor',
    buildingType: 'Hotel',
    location: 'Bogor, Jawa Barat',
    year: 2010,
    status: 'Selesai',
    workPackage: 'Struktur dan Arsitektur',
    floors: '6 Lantai + 1 Basement',
    description: 'Pembangunan Hotel Amaris 6 lantai dengan 1 basement di Bogor, mencakup pekerjaan struktur beton bertulang dan arsitektur eksterior-interior hotel bintang tiga dengan konsep modern tropis.',
    image: 'https://readdy.ai/api/search-image?query=modern%20hotel%20building%206%20floors%20basement%20exterior%20night%20view%20Bogor%2C%20warm%20amber%20facade%20lighting%2C%20dark%20dramatic%20sky%2C%20tropical%20modern%20architecture%2C%20moody%20cinematic%20photography%2C%20deep%20shadows%2C%20ultra%20realistic&width=800&height=600&seq=wmm-r6-2010&orientation=landscape',
    images: [
      'https://readdy.ai/api/search-image?query=modern%20hotel%20building%206%20floors%20basement%20exterior%20night%20view%20Bogor%2C%20warm%20amber%20facade%20lighting%2C%20dark%20dramatic%20sky%2C%20tropical%20modern%20architecture%2C%20moody%20cinematic%20photography%2C%20deep%20shadows%2C%20ultra%20realistic&width=800&height=600&seq=wmm-r6-2010&orientation=landscape',
    ],
    client: 'PT. Graha Sahari Utama',
    value: 'Rp 12.550.000.000,-',
  },
  {
    id: 7,
    name: 'Grand Bangka City',
    buildingType: 'Mall',
    location: 'Pangkal Pinang, Bangka Belitung',
    year: 2010,
    status: 'Selesai',
    workPackage: 'Struktur, Arsitektur dan MEP',
    description: 'Pembangunan Grand Bangka City di Pangkal Pinang mencakup pekerjaan struktur, arsitektur, dan MEP lengkap untuk kawasan mixed-use komersial terbesar di Bangka Belitung.',
    image: 'https://readdy.ai/api/search-image?query=large%20mixed%20use%20commercial%20complex%20building%20exterior%20night%20view%20Bangka%2C%20warm%20amber%20facade%20lighting%2C%20dark%20dramatic%20sky%2C%20modern%20architecture%20multiple%20buildings%2C%20moody%20cinematic%20photography%2C%20deep%20shadows%2C%20ultra%20realistic&width=800&height=600&seq=wmm-r7-2010&orientation=landscape',
    images: [
      'https://readdy.ai/api/search-image?query=large%20mixed%20use%20commercial%20complex%20building%20exterior%20night%20view%20Bangka%2C%20warm%20amber%20facade%20lighting%2C%20dark%20dramatic%20sky%2C%20modern%20architecture%20multiple%20buildings%2C%20moody%20cinematic%20photography%2C%20deep%20shadows%2C%20ultra%20realistic&width=800&height=600&seq=wmm-r7-2010&orientation=landscape',
    ],
    client: 'PT. Pinang Jaya Murni',
    value: 'Rp 57.753.200.000,-',
  },
  {
    id: 8,
    name: 'U Residence',
    buildingType: 'Lainnya',
    location: 'Karawaci, Tangerang',
    year: 2010,
    status: 'Selesai',
    workPackage: 'Bor Pile dan Retention System',
    description: 'Pekerjaan Bor Pile dan Retention System untuk U Residence di Karawaci, mencakup pekerjaan pondasi dalam dan sistem penahan tanah untuk pembangunan hunian vertikal modern.',
    image: 'https://readdy.ai/api/search-image?query=deep%20foundation%20bored%20pile%20construction%20site%20dusk%2C%20drilling%20rig%20machine%20warm%20amber%20work%20lights%2C%20dark%20dramatic%20sky%2C%20concrete%20pile%20installation%2C%20moody%20cinematic%20photography%2C%20deep%20shadows%2C%20ultra%20realistic&width=800&height=600&seq=wmm-r8-2010&orientation=landscape',
    images: [
      'https://readdy.ai/api/search-image?query=deep%20foundation%20bored%20pile%20construction%20site%20dusk%2C%20drilling%20rig%20machine%20warm%20amber%20work%20lights%2C%20dark%20dramatic%20sky%2C%20concrete%20pile%20installation%2C%20moody%20cinematic%20photography%2C%20deep%20shadows%2C%20ultra%20realistic&width=800&height=600&seq=wmm-r8-2010&orientation=landscape',
    ],
    client: 'PT. Supermal Karawaci',
    value: 'Rp 14.300.000.000,-',
  },
  {
    id: 9,
    name: 'Hotel Amaris Tendean',
    buildingType: 'Hotel',
    location: 'Jl. Tendean, Jakarta Selatan',
    year: 2010,
    status: 'Selesai',
    workPackage: 'Struktur dan Arsitektur',
    floors: '17 Lantai + 1 Basement',
    description: 'Pembangunan Hotel Amaris 17 lantai dengan 1 basement di Jl. Tendean Jakarta Selatan, mencakup pekerjaan struktur beton bertulang dan arsitektur eksterior-interior hotel bintang tiga bertingkat tinggi.',
    image: 'https://readdy.ai/api/search-image?query=tall%20hotel%20building%2017%20floors%20exterior%20night%20view%20Jakarta%20Selatan%2C%20warm%20amber%20facade%20lighting%2C%20dark%20dramatic%20sky%2C%20modern%20high%20rise%20architecture%2C%20moody%20cinematic%20photography%2C%20deep%20shadows%2C%20ultra%20realistic&width=800&height=600&seq=wmm-r9-2010&orientation=landscape',
    images: [
      'https://readdy.ai/api/search-image?query=tall%20hotel%20building%2017%20floors%20exterior%20night%20view%20Jakarta%20Selatan%2C%20warm%20amber%20facade%20lighting%2C%20dark%20dramatic%20sky%2C%20modern%20high%20rise%20architecture%2C%20moody%20cinematic%20photography%2C%20deep%20shadows%2C%20ultra%20realistic&width=800&height=600&seq=wmm-r9-2010&orientation=landscape',
    ],
    client: 'PT. Prima Multi Utama Lestari',
    value: 'Rp 13.700.000.000,-',
  },
  {
    id: 10,
    name: 'Sekolah Tarsisius 1',
    buildingType: 'Sekolah',
    location: 'Jakarta Pusat',
    year: 2010,
    status: 'Selesai',
    workPackage: 'Struktur, Arsitektur dan Plumbing',
    description: 'Pembangunan Sekolah Tarsisius 1 Jakarta Pusat mencakup pekerjaan struktur, arsitektur, dan plumbing lengkap untuk fasilitas pendidikan berkualitas tinggi yang modern dan representatif.',
    image: 'https://readdy.ai/api/search-image?query=modern%20school%20building%20exterior%20night%20view%20Jakarta%2C%20warm%20amber%20facade%20lighting%2C%20dark%20dramatic%20sky%2C%20educational%20building%20architecture%20concrete%20glass%2C%20moody%20cinematic%20photography%2C%20deep%20shadows%2C%20ultra%20realistic&width=800&height=600&seq=wmm-r10-2010&orientation=landscape',
    images: [
      'https://readdy.ai/api/search-image?query=modern%20school%20building%20exterior%20night%20view%20Jakarta%2C%20warm%20amber%20facade%20lighting%2C%20dark%20dramatic%20sky%2C%20educational%20building%20architecture%20concrete%20glass%2C%20moody%20cinematic%20photography%2C%20deep%20shadows%2C%20ultra%20realistic&width=800&height=600&seq=wmm-r10-2010&orientation=landscape',
    ],
    client: 'Yayasan Bunda Hati Kudus',
    value: 'Rp 20.400.000.000,-',
  },

  // ─── 2011 ───
  {
    id: 11,
    name: 'Hotel Edelwis Yogyakarta',
    buildingType: 'Hotel',
    location: 'Yogyakarta',
    year: 2011,
    status: 'Selesai',
    workPackage: 'Struktur, Arsitektur dan Plumbing',
    floors: '7 Lantai + 1 Basement',
    description: 'Pembangunan Hotel Edelwis 7 lantai dengan 1 basement di Yogyakarta, mencakup pekerjaan struktur beton bertulang, arsitektur eksterior-interior, dan sistem plumbing lengkap untuk hotel bintang tiga.',
    image: 'https://readdy.ai/api/search-image?query=modern%20hotel%20building%207%20floors%20basement%20exterior%20night%20view%20Yogyakarta%2C%20warm%20amber%20facade%20lighting%2C%20dark%20dramatic%20sky%2C%20Javanese%20modern%20architecture%2C%20moody%20cinematic%20photography%2C%20deep%20shadows%2C%20ultra%20realistic&width=800&height=600&seq=wmm-r11-2011&orientation=landscape',
    images: [
      'https://readdy.ai/api/search-image?query=modern%20hotel%20building%207%20floors%20basement%20exterior%20night%20view%20Yogyakarta%2C%20warm%20amber%20facade%20lighting%2C%20dark%20dramatic%20sky%2C%20Javanese%20modern%20architecture%2C%20moody%20cinematic%20photography%2C%20deep%20shadows%2C%20ultra%20realistic&width=800&height=600&seq=wmm-r11-2011&orientation=landscape',
    ],
    client: 'PT. Arga Gumilang',
    value: 'Rp 13.035.000.000,-',
  },
  {
    id: 12,
    name: 'Hotel Sintesa Palembang',
    buildingType: 'Hotel',
    location: 'Palembang, Sumatera Selatan',
    year: 2011,
    status: 'Selesai',
    workPackage: 'Struktur dan Arsitektur',
    floors: '8 Lantai',
    description: 'Pembangunan Hotel Sintesa 8 lantai di Palembang, mencakup pekerjaan struktur beton bertulang dan arsitektur eksterior-interior hotel bintang empat dengan desain modern dan elegan.',
    image: 'https://readdy.ai/api/search-image?query=modern%20hotel%20building%208%20floors%20exterior%20night%20view%20Palembang%2C%20warm%20amber%20facade%20lighting%2C%20dark%20dramatic%20sky%2C%20contemporary%20architecture%2C%20moody%20cinematic%20photography%2C%20deep%20shadows%2C%20ultra%20realistic&width=800&height=600&seq=wmm-r12-2011&orientation=landscape',
    images: [
      'https://readdy.ai/api/search-image?query=modern%20hotel%20building%208%20floors%20exterior%20night%20view%20Palembang%2C%20warm%20amber%20facade%20lighting%2C%20dark%20dramatic%20sky%2C%20contemporary%20architecture%2C%20moody%20cinematic%20photography%2C%20deep%20shadows%2C%20ultra%20realistic&width=800&height=600&seq=wmm-r12-2011&orientation=landscape',
    ],
    client: 'PT. Puncak Mustika Bersama',
    value: 'Rp 15.602.000.000,-',
  },
  {
    id: 13,
    name: 'Bangunan Fasilitas Indofood Jakarta',
    buildingType: 'Lainnya',
    location: 'Jakarta',
    year: 2011,
    status: 'Selesai',
    workPackage: 'Struktur, Arsitektur dan MEP',
    description: 'Pembangunan bangunan fasilitas Indofood di Jakarta mencakup pekerjaan struktur, arsitektur, dan MEP lengkap untuk fasilitas industri makanan terkemuka di Indonesia.',
    image: 'https://readdy.ai/api/search-image?query=modern%20industrial%20facility%20building%20exterior%20night%20view%20Jakarta%2C%20warm%20amber%20facade%20lighting%2C%20dark%20dramatic%20sky%2C%20corporate%20industrial%20architecture%2C%20moody%20cinematic%20photography%2C%20deep%20shadows%2C%20ultra%20realistic&width=800&height=600&seq=wmm-r13-2011&orientation=landscape',
    images: [
      'https://readdy.ai/api/search-image?query=modern%20industrial%20facility%20building%20exterior%20night%20view%20Jakarta%2C%20warm%20amber%20facade%20lighting%2C%20dark%20dramatic%20sky%2C%20corporate%20industrial%20architecture%2C%20moody%20cinematic%20photography%2C%20deep%20shadows%2C%20ultra%20realistic&width=800&height=600&seq=wmm-r13-2011&orientation=landscape',
    ],
    client: 'PT Indofood Sukses Makmur',
    value: 'Rp 7.436.000.000,-',
  },
  {
    id: 14,
    name: 'Hotel De Java Bandung',
    buildingType: 'Hotel',
    location: 'Bandung, Jawa Barat',
    year: 2011,
    status: 'Selesai',
    workPackage: 'Struktur, Arsitektur dan Plumbing',
    floors: '6 Lantai + 1 Basement',
    description: 'Pembangunan Hotel De Java 6 lantai dengan 1 basement di Bandung, mencakup pekerjaan struktur beton bertulang, arsitektur eksterior-interior, dan sistem plumbing lengkap untuk hotel bintang empat.',
    image: 'https://readdy.ai/api/search-image?query=elegant%20hotel%20building%206%20floors%20basement%20exterior%20night%20view%20Bandung%2C%20warm%20amber%20facade%20lighting%2C%20dark%20dramatic%20sky%2C%20colonial%20modern%20architecture%2C%20moody%20cinematic%20photography%2C%20deep%20shadows%2C%20ultra%20realistic&width=800&height=600&seq=wmm-r14-2011&orientation=landscape',
    images: [
      'https://readdy.ai/api/search-image?query=elegant%20hotel%20building%206%20floors%20basement%20exterior%20night%20view%20Bandung%2C%20warm%20amber%20facade%20lighting%2C%20dark%20dramatic%20sky%2C%20colonial%20modern%20architecture%2C%20moody%20cinematic%20photography%2C%20deep%20shadows%2C%20ultra%20realistic&width=800&height=600&seq=wmm-r14-2011&orientation=landscape',
    ],
    client: 'Bpk. Sukiamto Candra',
    value: 'Rp 21.554.500.000,-',
  },
  {
    id: 15,
    name: 'Hotel Amaris Panglima Polim',
    buildingType: 'Hotel',
    location: 'Jl. Panglima Polim, Jakarta Selatan',
    year: 2011,
    status: 'Selesai',
    workPackage: 'Struktur, Arsitektur dan Plumbing',
    floors: '4 Lantai + 1 Basement',
    description: 'Pembangunan Hotel Amaris Panglima Polim 4 lantai dengan 1 basement di Jakarta Selatan, mencakup pekerjaan struktur, arsitektur, dan plumbing untuk hotel bintang tiga di kawasan premium Jakarta.',
    image: 'https://readdy.ai/api/search-image?query=modern%20hotel%20building%204%20floors%20basement%20exterior%20night%20view%20Jakarta%20Selatan%2C%20warm%20amber%20facade%20lighting%2C%20dark%20dramatic%20sky%2C%20contemporary%20architecture%2C%20moody%20cinematic%20photography%2C%20deep%20shadows%2C%20ultra%20realistic&width=800&height=600&seq=wmm-r15-2011&orientation=landscape',
    images: [
      'https://readdy.ai/api/search-image?query=modern%20hotel%20building%204%20floors%20basement%20exterior%20night%20view%20Jakarta%20Selatan%2C%20warm%20amber%20facade%20lighting%2C%20dark%20dramatic%20sky%2C%20contemporary%20architecture%2C%20moody%20cinematic%20photography%2C%20deep%20shadows%2C%20ultra%20realistic&width=800&height=600&seq=wmm-r15-2011&orientation=landscape',
    ],
    client: 'PT. Graha Multi Utama',
    value: 'Rp 5.918.000.000,-',
  },
  {
    id: 16,
    name: 'Hotel Grand Central Pekanbaru',
    buildingType: 'Hotel',
    location: 'Pekanbaru, Riau',
    year: 2011,
    status: 'Selesai',
    workPackage: 'Arsitektur',
    floors: '9 Lantai + 1 Basement',
    description: 'Pekerjaan arsitektur Hotel Grand Central 9 lantai dengan 1 basement di Pekanbaru, mencakup desain dan pelaksanaan arsitektur eksterior-interior hotel bintang empat yang megah dan representatif.',
    image: 'https://readdy.ai/api/search-image?query=grand%20hotel%20building%209%20floors%20basement%20exterior%20night%20view%20Pekanbaru%2C%20warm%20amber%20facade%20lighting%2C%20dark%20dramatic%20sky%2C%20luxurious%20architecture%2C%20moody%20cinematic%20photography%2C%20deep%20shadows%2C%20ultra%20realistic&width=800&height=600&seq=wmm-r16-2011&orientation=landscape',
    images: [
      'https://readdy.ai/api/search-image?query=grand%20hotel%20building%209%20floors%20basement%20exterior%20night%20view%20Pekanbaru%2C%20warm%20amber%20facade%20lighting%2C%20dark%20dramatic%20sky%2C%20luxurious%20architecture%2C%20moody%20cinematic%20photography%2C%20deep%20shadows%2C%20ultra%20realistic&width=800&height=600&seq=wmm-r16-2011&orientation=landscape',
    ],
    client: 'PT. Tribersa',
    value: 'Rp 20.460.000.000,-',
  },
  {
    id: 17,
    name: 'Gudang Indofood Cibitung',
    buildingType: 'Gudang',
    location: 'Cibitung, Bekasi',
    year: 2011,
    status: 'Selesai',
    workPackage: 'Struktur, Arsitektur dan MEP',
    buildingArea: '7.000 m²',
    description: 'Pembangunan gudang Indofood di Cibitung seluas 7.000 m², mencakup pekerjaan struktur baja dan beton, arsitektur, serta MEP lengkap untuk fasilitas logistik dan distribusi skala besar.',
    image: 'https://readdy.ai/api/search-image?query=large%20industrial%20warehouse%20building%20exterior%20night%20view%20Cibitung%20Bekasi%2C%20warm%20amber%20facade%20lighting%2C%20dark%20dramatic%20sky%2C%20steel%20structure%20industrial%20architecture%2C%20moody%20cinematic%20photography%2C%20deep%20shadows%2C%20ultra%20realistic&width=800&height=600&seq=wmm-r17-2011&orientation=landscape',
    images: [
      'https://readdy.ai/api/search-image?query=large%20industrial%20warehouse%20building%20exterior%20night%20view%20Cibitung%20Bekasi%2C%20warm%20amber%20facade%20lighting%2C%20dark%20dramatic%20sky%2C%20steel%20structure%20industrial%20architecture%2C%20moody%20cinematic%20photography%2C%20deep%20shadows%2C%20ultra%20realistic&width=800&height=600&seq=wmm-r17-2011&orientation=landscape',
    ],
    client: 'PT Indofood Sukses Makmur',
    value: 'Rp 25.190.000.000,-',
  },

  // ─── 2012 ───
  {
    id: 18,
    name: 'Hotel Holiday Inn Express Jakarta',
    buildingType: 'Hotel',
    location: 'Jakarta',
    year: 2012,
    status: 'Selesai',
    workPackage: 'Arsitektur',
    floors: '10 Lantai',
    description: 'Pekerjaan arsitektur Hotel Holiday Inn Express 10 lantai di Jakarta, mencakup desain dan pelaksanaan arsitektur eksterior-interior hotel bintang empat internasional yang modern dan fungsional.',
    image: 'https://readdy.ai/api/search-image?query=modern%20international%20hotel%20building%2010%20floors%20exterior%20night%20view%20Jakarta%2C%20warm%20amber%20facade%20lighting%2C%20dark%20dramatic%20sky%2C%20contemporary%20glass%20architecture%2C%20moody%20cinematic%20photography%2C%20deep%20shadows%2C%20ultra%20realistic&width=800&height=600&seq=wmm-r18-2012&orientation=landscape',
    images: [
      'https://readdy.ai/api/search-image?query=modern%20international%20hotel%20building%2010%20floors%20exterior%20night%20view%20Jakarta%2C%20warm%20amber%20facade%20lighting%2C%20dark%20dramatic%20sky%2C%20contemporary%20glass%20architecture%2C%20moody%20cinematic%20photography%2C%20deep%20shadows%2C%20ultra%20realistic&width=800&height=600&seq=wmm-r18-2012&orientation=landscape',
    ],
    client: 'PT. Sentra Graha Kencana',
    value: 'Rp 12.700.000.000,-',
  },
  {
    id: 19,
    name: 'Hotel Aston Jambi',
    buildingType: 'Hotel',
    location: 'Jambi',
    year: 2012,
    status: 'Selesai',
    workPackage: 'Struktur, Arsitektur dan Plumbing',
    floors: '10 Lantai',
    description: 'Pembangunan Hotel Aston Jambi 10 lantai mencakup pekerjaan struktur beton bertulang, arsitektur eksterior-interior, dan sistem plumbing lengkap untuk hotel bintang empat di Jambi.',
    image: 'https://readdy.ai/api/search-image?query=tall%20hotel%20building%2010%20floors%20exterior%20night%20view%20Jambi%2C%20warm%20amber%20facade%20lighting%2C%20dark%20dramatic%20sky%2C%20modern%20architecture%2C%20moody%20cinematic%20photography%2C%20deep%20shadows%2C%20ultra%20realistic&width=800&height=600&seq=wmm-r19-2012&orientation=landscape',
    images: [
      'https://readdy.ai/api/search-image?query=tall%20hotel%20building%2010%20floors%20exterior%20night%20view%20Jambi%2C%20warm%20amber%20facade%20lighting%2C%20dark%20dramatic%20sky%2C%20modern%20architecture%2C%20moody%20cinematic%20photography%2C%20deep%20shadows%2C%20ultra%20realistic&width=800&height=600&seq=wmm-r19-2012&orientation=landscape',
    ],
    client: 'PT. Sabang Raya Hotel',
    value: 'Rp 37.268.000.000,-',
  },
  {
    id: 20,
    name: 'Hotel @Home Semarang',
    buildingType: 'Hotel',
    location: 'Semarang, Jawa Tengah',
    year: 2012,
    status: 'Selesai',
    workPackage: 'Struktur, Arsitektur dan Plumbing',
    floors: '11 Lantai',
    description: 'Pembangunan Hotel @Home Semarang 11 lantai mencakup pekerjaan struktur beton bertulang, arsitektur eksterior-interior, dan sistem plumbing lengkap untuk hotel bintang tiga modern di Semarang.',
    image: 'https://readdy.ai/api/search-image?query=modern%20hotel%20building%2011%20floors%20exterior%20night%20view%20Semarang%2C%20warm%20amber%20facade%20lighting%2C%20dark%20dramatic%20sky%2C%20contemporary%20architecture%2C%20moody%20cinematic%20photography%2C%20deep%20shadows%2C%20ultra%20realistic&width=800&height=600&seq=wmm-r20-2012&orientation=landscape',
    images: [
      'https://readdy.ai/api/search-image?query=modern%20hotel%20building%2011%20floors%20exterior%20night%20view%20Semarang%2C%20warm%20amber%20facade%20lighting%2C%20dark%20dramatic%20sky%2C%20contemporary%20architecture%2C%20moody%20cinematic%20photography%2C%20deep%20shadows%2C%20ultra%20realistic&width=800&height=600&seq=wmm-r20-2012&orientation=landscape',
    ],
    client: 'PT. Welstand Park Realty',
    value: 'Rp 22.880.000.000,-',
  },
  {
    id: 21,
    name: 'Hotel Wizh Balikpapan',
    buildingType: 'Hotel',
    location: 'Balikpapan, Kalimantan Timur',
    year: 2012,
    status: 'Selesai',
    workPackage: 'Struktur, Arsitektur dan Plumbing',
    floors: '10 Lantai',
    description: 'Pembangunan Hotel Wizh Balikpapan 10 lantai mencakup pekerjaan struktur beton bertulang, arsitektur eksterior-interior, dan sistem plumbing lengkap untuk hotel bintang empat di Balikpapan.',
    image: 'https://readdy.ai/api/search-image?query=modern%20hotel%20building%2010%20floors%20exterior%20night%20view%20Balikpapan%20Kalimantan%2C%20warm%20amber%20facade%20lighting%2C%20dark%20dramatic%20sky%2C%20contemporary%20architecture%2C%20moody%20cinematic%20photography%2C%20deep%20shadows%2C%20ultra%20realistic&width=800&height=600&seq=wmm-r21-2012&orientation=landscape',
    images: [
      'https://readdy.ai/api/search-image?query=modern%20hotel%20building%2010%20floors%20exterior%20night%20view%20Balikpapan%20Kalimantan%2C%20warm%20amber%20facade%20lighting%2C%20dark%20dramatic%20sky%2C%20contemporary%20architecture%2C%20moody%20cinematic%20photography%2C%20deep%20shadows%2C%20ultra%20realistic&width=800&height=600&seq=wmm-r21-2012&orientation=landscape',
    ],
    client: 'PT. Intiland Jakarta',
    value: 'Rp 24.750.000.000,-',
  },
  {
    id: 22,
    name: 'Hotel Klapa Breeze Pecatu',
    buildingType: 'Hotel',
    location: 'Pecatu, Bali',
    year: 2012,
    status: 'Selesai',
    workPackage: 'Arsitektur',
    floors: '4 Lantai',
    description: 'Pekerjaan arsitektur Hotel Klapa Breeze 4 lantai di Pecatu Bali, mencakup desain dan pelaksanaan arsitektur eksterior-interior resort hotel bintang lima dengan konsep tropis Bali yang mewah.',
    image: 'https://readdy.ai/api/search-image?query=luxury%20resort%20hotel%204%20floors%20exterior%20night%20view%20Pecatu%20Bali%2C%20warm%20amber%20facade%20lighting%2C%20dark%20dramatic%20sky%2C%20tropical%20Balinese%20architecture%2C%20moody%20cinematic%20photography%2C%20deep%20shadows%2C%20ultra%20realistic&width=800&height=600&seq=wmm-r22-2012&orientation=landscape',
    images: [
      'https://readdy.ai/api/search-image?query=luxury%20resort%20hotel%204%20floors%20exterior%20night%20view%20Pecatu%20Bali%2C%20warm%20amber%20facade%20lighting%2C%20dark%20dramatic%20sky%2C%20tropical%20Balinese%20architecture%2C%20moody%20cinematic%20photography%2C%20deep%20shadows%2C%20ultra%20realistic&width=800&height=600&seq=wmm-r22-2012&orientation=landscape',
    ],
    client: 'PT Bright Source Pecatu Indonesia',
    value: 'Rp 26.365.900.000,-',
  },
  {
    id: 23,
    name: 'Kantor Gelora Aksara Pratama Jakarta',
    buildingType: 'Kantor',
    location: 'Jakarta',
    year: 2012,
    status: 'Selesai',
    workPackage: 'Struktur, Arsitektur dan MEP',
    floors: '4 Lantai',
    description: 'Pembangunan gedung kantor 4 lantai di Jakarta mencakup pekerjaan struktur beton bertulang, arsitektur eksterior-interior, dan MEP lengkap untuk fasilitas perkantoran modern dan representatif.',
    image: 'https://readdy.ai/api/search-image?query=modern%20office%20building%204%20floors%20exterior%20night%20view%20Jakarta%2C%20warm%20amber%20facade%20lighting%2C%20dark%20dramatic%20sky%2C%20corporate%20architecture%20glass%20concrete%2C%20moody%20cinematic%20photography%2C%20deep%20shadows%2C%20ultra%20realistic&width=800&height=600&seq=wmm-r23-2012&orientation=landscape',
    images: [
      'https://readdy.ai/api/search-image?query=modern%20office%20building%204%20floors%20exterior%20night%20view%20Jakarta%2C%20warm%20amber%20facade%20lighting%2C%20dark%20dramatic%20sky%2C%20corporate%20architecture%20glass%20concrete%2C%20moody%20cinematic%20photography%2C%20deep%20shadows%2C%20ultra%20realistic&width=800&height=600&seq=wmm-r23-2012&orientation=landscape',
    ],
    client: 'PT. Gelora Aksara Pratama',
    value: 'Rp 32.785.000.000,-',
  },
  {
    id: 24,
    name: 'Kampus CWE',
    buildingType: 'Kampus',
    location: 'Jakarta',
    year: 2012,
    status: 'Selesai',
    workPackage: 'Struktur, Arsitektur dan MEP',
    floors: '8 Lantai',
    description: 'Pembangunan Kampus Citra Widya Edukasi 8 lantai mencakup pekerjaan struktur beton bertulang, arsitektur eksterior-interior, dan MEP lengkap untuk fasilitas pendidikan tinggi modern.',
    image: 'https://readdy.ai/api/search-image?query=modern%20university%20campus%20building%208%20floors%20exterior%20night%20view%20Jakarta%2C%20warm%20amber%20facade%20lighting%2C%20dark%20dramatic%20sky%2C%20educational%20architecture%2C%20moody%20cinematic%20photography%2C%20deep%20shadows%2C%20ultra%20realistic&width=800&height=600&seq=wmm-r24-2012&orientation=landscape',
    images: [
      'https://readdy.ai/api/search-image?query=modern%20university%20campus%20building%208%20floors%20exterior%20night%20view%20Jakarta%2C%20warm%20amber%20facade%20lighting%2C%20dark%20dramatic%20sky%2C%20educational%20architecture%2C%20moody%20cinematic%20photography%2C%20deep%20shadows%2C%20ultra%20realistic&width=800&height=600&seq=wmm-r24-2012&orientation=landscape',
    ],
    client: 'Yayasan Citra Widya Edukasi',
    value: 'Rp 40.400.000.000,-',
  },
  {
    id: 25,
    name: 'Hotel Java Palace Cikarang',
    buildingType: 'Hotel',
    location: 'Cikarang, Bekasi',
    year: 2012,
    status: 'Selesai',
    workPackage: 'Struktur, Arsitektur dan MEP',
    floors: '11 Lantai',
    description: 'Pembangunan Hotel Java Palace 11 lantai di Cikarang mencakup pekerjaan struktur beton bertulang, arsitektur eksterior-interior, dan MEP lengkap untuk hotel bintang empat di kawasan industri Cikarang.',
    image: 'https://readdy.ai/api/search-image?query=tall%20hotel%20building%2011%20floors%20exterior%20night%20view%20Cikarang%20Bekasi%2C%20warm%20amber%20facade%20lighting%2C%20dark%20dramatic%20sky%2C%20modern%20architecture%2C%20moody%20cinematic%20photography%2C%20deep%20shadows%2C%20ultra%20realistic&width=800&height=600&seq=wmm-r25-2012&orientation=landscape',
    images: [
      'https://readdy.ai/api/search-image?query=tall%20hotel%20building%2011%20floors%20exterior%20night%20view%20Cikarang%20Bekasi%2C%20warm%20amber%20facade%20lighting%2C%20dark%20dramatic%20sky%2C%20modern%20architecture%2C%20moody%20cinematic%20photography%2C%20deep%20shadows%2C%20ultra%20realistic&width=800&height=600&seq=wmm-r25-2012&orientation=landscape',
    ],
    client: 'PT Java Prima Global',
    value: 'Rp 58.308.771.000,-',
  },
  {
    id: 26,
    name: 'Hotel Pesona Alam Cisarua',
    buildingType: 'Hotel',
    location: 'Cisarua, Bogor',
    year: 2012,
    status: 'Selesai',
    workPackage: 'Struktur dan Arsitektur',
    description: 'Pembangunan Hotel Pesona Alam Cisarua mencakup pekerjaan struktur beton bertulang dan arsitektur eksterior-interior resort hotel dengan konsep alam pegunungan yang asri dan mewah.',
    image: 'https://readdy.ai/api/search-image?query=mountain%20resort%20hotel%20building%20exterior%20night%20view%20Cisarua%20Bogor%2C%20warm%20amber%20facade%20lighting%2C%20dark%20dramatic%20sky%2C%20natural%20architecture%20surrounded%20by%20trees%2C%20moody%20cinematic%20photography%2C%20deep%20shadows%2C%20ultra%20realistic&width=800&height=600&seq=wmm-r26-2012&orientation=landscape',
    images: [
      'https://readdy.ai/api/search-image?query=mountain%20resort%20hotel%20building%20exterior%20night%20view%20Cisarua%20Bogor%2C%20warm%20amber%20facade%20lighting%2C%20dark%20dramatic%20sky%2C%20natural%20architecture%20surrounded%20by%20trees%2C%20moody%20cinematic%20photography%2C%20deep%20shadows%2C%20ultra%20realistic&width=800&height=600&seq=wmm-r26-2012&orientation=landscape',
    ],
    client: 'PT Kusuma Anugrah Damai Sejahtera',
    value: 'Rp 45.017.500.000,-',
  },
  {
    id: 27,
    name: 'Hotel Marriott Legian',
    buildingType: 'Hotel',
    location: 'Legian, Bali',
    year: 2012,
    status: 'Selesai',
    workPackage: 'Struktur, Arsitektur dan Plumbing',
    description: 'Pembangunan Hotel Marriott Legian Bali mencakup pekerjaan struktur beton bertulang, arsitektur eksterior-interior, dan sistem plumbing lengkap untuk hotel bintang lima internasional di kawasan Legian Bali.',
    image: 'https://readdy.ai/api/search-image?query=luxury%20five%20star%20hotel%20building%20exterior%20night%20view%20Legian%20Bali%2C%20warm%20amber%20facade%20lighting%2C%20dark%20dramatic%20sky%2C%20Balinese%20luxury%20architecture%2C%20moody%20cinematic%20photography%2C%20deep%20shadows%2C%20ultra%20realistic&width=800&height=600&seq=wmm-r27-2012&orientation=landscape',
    images: [
      'https://readdy.ai/api/search-image?query=luxury%20five%20star%20hotel%20building%20exterior%20night%20view%20Legian%20Bali%2C%20warm%20amber%20facade%20lighting%2C%20dark%20dramatic%20sky%2C%20Balinese%20luxury%20architecture%2C%20moody%20cinematic%20photography%2C%20deep%20shadows%2C%20ultra%20realistic&width=800&height=600&seq=wmm-r27-2012&orientation=landscape',
    ],
    client: 'PT Wihensa Bali Putera',
    value: 'Rp 14.700.000.000,-',
  },
  {
    id: 28,
    name: 'Kantor Halim Perdanakusuma',
    buildingType: 'Kantor',
    location: 'Jl. Halim Perdanakusuma, Jakarta',
    year: 2012,
    status: 'Selesai',
    workPackage: 'Struktur dan Arsitektur',
    floors: '4 Lantai',
    description: 'Pembangunan gedung kantor 4 lantai di Jl. Halim Perdanakusuma Jakarta mencakup pekerjaan struktur beton bertulang dan arsitektur eksterior-interior untuk fasilitas perkantoran modern.',
    image: 'https://readdy.ai/api/search-image?query=modern%20office%20building%204%20floors%20exterior%20night%20view%20Halim%20Jakarta%2C%20warm%20amber%20facade%20lighting%2C%20dark%20dramatic%20sky%2C%20corporate%20architecture%2C%20moody%20cinematic%20photography%2C%20deep%20shadows%2C%20ultra%20realistic&width=800&height=600&seq=wmm-r28-2012&orientation=landscape',
    images: [
      'https://readdy.ai/api/search-image?query=modern%20office%20building%204%20floors%20exterior%20night%20view%20Halim%20Jakarta%2C%20warm%20amber%20facade%20lighting%2C%20dark%20dramatic%20sky%2C%20corporate%20architecture%2C%20moody%20cinematic%20photography%2C%20deep%20shadows%2C%20ultra%20realistic&width=800&height=600&seq=wmm-r28-2012&orientation=landscape',
    ],
    client: 'PT Prima Media Energi',
    value: 'Rp 19.600.000.000,-',
  },

  // ─── 2013 ───
  {
    id: 29,
    name: 'De Vins Sky Villa',
    buildingType: 'Apartemen',
    location: 'Jakarta',
    year: 2013,
    status: 'Selesai',
    workPackage: 'Struktur',
    description: 'Pekerjaan struktur De Vins Sky Villa di Jakarta mencakup pembangunan struktur beton bertulang untuk hunian vertikal premium dengan konsep sky villa yang eksklusif dan modern.',
    image: 'https://readdy.ai/api/search-image?query=luxury%20sky%20villa%20residential%20building%20exterior%20night%20view%20Jakarta%2C%20warm%20amber%20facade%20lighting%2C%20dark%20dramatic%20sky%2C%20premium%20high%20rise%20architecture%2C%20moody%20cinematic%20photography%2C%20deep%20shadows%2C%20ultra%20realistic&width=800&height=600&seq=wmm-r29-2013&orientation=landscape',
    images: [
      'https://readdy.ai/api/search-image?query=luxury%20sky%20villa%20residential%20building%20exterior%20night%20view%20Jakarta%2C%20warm%20amber%20facade%20lighting%2C%20dark%20dramatic%20sky%2C%20premium%20high%20rise%20architecture%2C%20moody%20cinematic%20photography%2C%20deep%20shadows%2C%20ultra%20realistic&width=800&height=600&seq=wmm-r29-2013&orientation=landscape',
    ],
    client: 'PT Duta Esa Vins',
    value: 'Rp 24.000.000.000,-',
  },
  {
    id: 30,
    name: 'The Mansion @ Dukuh Golf Kemayoran',
    buildingType: 'Apartemen',
    location: 'Kemayoran, Jakarta Pusat',
    year: 2013,
    status: 'Selesai',
    workPackage: 'Struktur Access Ramp',
    description: 'Pekerjaan struktur access ramp The Mansion @ Dukuh Golf Kemayoran mencakup pembangunan struktur beton bertulang untuk akses ramp hunian premium di kawasan Kemayoran Jakarta.',
    image: 'https://readdy.ai/api/search-image?query=luxury%20apartment%20complex%20access%20ramp%20construction%20Kemayoran%20Jakarta%2C%20warm%20amber%20work%20lights%20dusk%2C%20dark%20dramatic%20sky%2C%20concrete%20structure%2C%20moody%20cinematic%20photography%2C%20deep%20shadows%2C%20ultra%20realistic&width=800&height=600&seq=wmm-r30-2013&orientation=landscape',
    images: [
      'https://readdy.ai/api/search-image?query=luxury%20apartment%20complex%20access%20ramp%20construction%20Kemayoran%20Jakarta%2C%20warm%20amber%20work%20lights%20dusk%2C%20dark%20dramatic%20sky%2C%20concrete%20structure%2C%20moody%20cinematic%20photography%2C%20deep%20shadows%2C%20ultra%20realistic&width=800&height=600&seq=wmm-r30-2013&orientation=landscape',
    ],
    client: 'PT Perkasa Abadi Jaya',
    value: 'Rp 3.927.077.000,-',
  },
  {
    id: 31,
    name: 'Hotel Aston Royal Bekasi',
    buildingType: 'Hotel',
    location: 'Bekasi, Jawa Barat',
    year: 2013,
    status: 'Selesai',
    workPackage: 'Struktur dan Arsitektur',
    floors: '12 Lantai',
    description: 'Pembangunan Hotel Aston Royal Bekasi 12 lantai mencakup pekerjaan struktur beton bertulang dan arsitektur eksterior-interior hotel bintang empat yang megah dan representatif di Bekasi.',
    image: 'https://readdy.ai/api/search-image?query=tall%20hotel%20building%2012%20floors%20exterior%20night%20view%20Bekasi%2C%20warm%20amber%20facade%20lighting%2C%20dark%20dramatic%20sky%2C%20modern%20luxury%20architecture%2C%20moody%20cinematic%20photography%2C%20deep%20shadows%2C%20ultra%20realistic&width=800&height=600&seq=wmm-r31-2013&orientation=landscape',
    images: [
      'https://readdy.ai/api/search-image?query=tall%20hotel%20building%2012%20floors%20exterior%20night%20view%20Bekasi%2C%20warm%20amber%20facade%20lighting%2C%20dark%20dramatic%20sky%2C%20modern%20luxury%20architecture%2C%20moody%20cinematic%20photography%2C%20deep%20shadows%2C%20ultra%20realistic&width=800&height=600&seq=wmm-r31-2013&orientation=landscape',
    ],
    client: 'PT Makmur Abadi Mulia',
    value: 'Rp 49.380.000.000,-',
  },
  {
    id: 32,
    name: 'Pusat Grosir Metro Cipulir',
    buildingType: 'Mall',
    location: 'Cipulir, Jakarta Selatan',
    year: 2013,
    status: 'Selesai',
    workPackage: 'Struktur dan Arsitektur',
    floors: '12 Lantai',
    description: 'Pembangunan Pusat Grosir Metro Cipulir 12 lantai mencakup pekerjaan struktur beton bertulang dan arsitektur eksterior-interior untuk pusat perbelanjaan grosir terbesar di kawasan Cipulir Jakarta Selatan.',
    image: 'https://readdy.ai/api/search-image?query=large%20wholesale%20shopping%20center%2012%20floors%20exterior%20night%20view%20Cipulir%20Jakarta%2C%20warm%20amber%20facade%20lighting%2C%20dark%20dramatic%20sky%2C%20commercial%20architecture%2C%20moody%20cinematic%20photography%2C%20deep%20shadows%2C%20ultra%20realistic&width=800&height=600&seq=wmm-r32-2013&orientation=landscape',
    images: [
      'https://readdy.ai/api/search-image?query=large%20wholesale%20shopping%20center%2012%20floors%20exterior%20night%20view%20Cipulir%20Jakarta%2C%20warm%20amber%20facade%20lighting%2C%20dark%20dramatic%20sky%2C%20commercial%20architecture%2C%20moody%20cinematic%20photography%2C%20deep%20shadows%2C%20ultra%20realistic&width=800&height=600&seq=wmm-r32-2013&orientation=landscape',
    ],
    client: 'PT Betawi Jaya Mandiri',
    value: 'Rp 92.000.000.000,-',
  },
  {
    id: 33,
    name: 'Basement Plant C AHM Cibitung',
    buildingType: 'Lainnya',
    location: 'Cibitung, Bekasi',
    year: 2013,
    status: 'Selesai',
    workPackage: 'Struktur dan Arsitektur',
    description: 'Pekerjaan struktur dan arsitektur Basement Plant C Astra Honda Motor di Cibitung mencakup pembangunan basement untuk fasilitas produksi otomotif terkemuka di Indonesia.',
    image: 'https://readdy.ai/api/search-image?query=automotive%20manufacturing%20plant%20basement%20construction%20Cibitung%20Bekasi%2C%20warm%20amber%20work%20lights%20dusk%2C%20dark%20dramatic%20sky%2C%20industrial%20concrete%20structure%2C%20moody%20cinematic%20photography%2C%20deep%20shadows%2C%20ultra%20realistic&width=800&height=600&seq=wmm-r33-2013&orientation=landscape',
    images: [
      'https://readdy.ai/api/search-image?query=automotive%20manufacturing%20plant%20basement%20construction%20Cibitung%20Bekasi%2C%20warm%20amber%20work%20lights%20dusk%2C%20dark%20dramatic%20sky%2C%20industrial%20concrete%20structure%2C%20moody%20cinematic%20photography%2C%20deep%20shadows%2C%20ultra%20realistic&width=800&height=600&seq=wmm-r33-2013&orientation=landscape',
    ],
    client: 'PT Astra Honda Motor Tbk',
    value: 'Rp 8.000.000.000,-',
  },
  {
    id: 34,
    name: 'De Vins Sky Villa',
    buildingType: 'Apartemen',
    location: 'Jakarta',
    year: 2013,
    status: 'Selesai',
    workPackage: 'Arsitektur',
    floors: '4 Lantai + 1 Basement',
    buildingArea: '11.300 m²',
    description: 'Pekerjaan arsitektur De Vins Sky Villa 4 lantai dengan 1 basement seluas 11.300 m² di Jakarta, mencakup desain dan pelaksanaan arsitektur eksterior-interior hunian premium sky villa yang eksklusif.',
    image: 'https://readdy.ai/api/search-image?query=luxury%20sky%20villa%204%20floors%20basement%20exterior%20night%20view%20Jakarta%2C%20warm%20amber%20facade%20lighting%2C%20dark%20dramatic%20sky%2C%20premium%20residential%20architecture%2C%20moody%20cinematic%20photography%2C%20deep%20shadows%2C%20ultra%20realistic&width=800&height=600&seq=wmm-r34-2013&orientation=landscape',
    images: [
      'https://readdy.ai/api/search-image?query=luxury%20sky%20villa%204%20floors%20basement%20exterior%20night%20view%20Jakarta%2C%20warm%20amber%20facade%20lighting%2C%20dark%20dramatic%20sky%2C%20premium%20residential%20architecture%2C%20moody%20cinematic%20photography%2C%20deep%20shadows%2C%20ultra%20realistic&width=800&height=600&seq=wmm-r34-2013&orientation=landscape',
    ],
    client: 'PT Duta Esa Vins',
    value: 'Rp 31.350.000.000,-',
  },
  {
    id: 35,
    name: 'Hotel Euphoria Jl. Patih Jlantik',
    buildingType: 'Hotel',
    location: 'Jl. Patih Jlantik, Bali',
    year: 2013,
    status: 'Selesai',
    workPackage: 'Struktur, Arsitektur dan Plumbing',
    floors: '4 Lantai + 1 Basement',
    buildingArea: '6.400 m²',
    description: 'Pembangunan Hotel Euphoria Bali 4 lantai dengan 1 basement seluas 6.400 m², mencakup pekerjaan struktur, arsitektur, dan plumbing untuk hotel bintang empat dengan konsep Bali modern.',
    image: 'https://readdy.ai/api/search-image?query=boutique%20hotel%204%20floors%20basement%20exterior%20night%20view%20Bali%2C%20warm%20amber%20facade%20lighting%2C%20dark%20dramatic%20sky%2C%20Balinese%20modern%20architecture%2C%20moody%20cinematic%20photography%2C%20deep%20shadows%2C%20ultra%20realistic&width=800&height=600&seq=wmm-r35-2013&orientation=landscape',
    images: [
      'https://readdy.ai/api/search-image?query=boutique%20hotel%204%20floors%20basement%20exterior%20night%20view%20Bali%2C%20warm%20amber%20facade%20lighting%2C%20dark%20dramatic%20sky%2C%20Balinese%20modern%20architecture%2C%20moody%20cinematic%20photography%2C%20deep%20shadows%2C%20ultra%20realistic&width=800&height=600&seq=wmm-r35-2013&orientation=landscape',
    ],
    client: 'PT Sentosa Mahakarya Putera',
    value: 'Rp 19.550.000.000,-',
  },
  {
    id: 36,
    name: 'Bali Paragon Hotel',
    buildingType: 'Hotel',
    location: 'Bali',
    year: 2013,
    status: 'Selesai',
    workPackage: 'Struktur, Arsitektur dan Plumbing',
    floors: '4 Lantai + 1 Basement',
    buildingArea: '18.200 m²',
    description: 'Pembangunan Bali Paragon Hotel 4 lantai dengan 1 basement seluas 18.200 m², mencakup pekerjaan struktur, arsitektur, dan plumbing untuk hotel bintang lima dengan konsep resort mewah Bali.',
    image: 'https://readdy.ai/api/search-image?query=luxury%20resort%20hotel%204%20floors%20basement%20exterior%20night%20view%20Bali%2C%20warm%20amber%20facade%20lighting%2C%20dark%20dramatic%20sky%2C%20Balinese%20luxury%20resort%20architecture%2C%20moody%20cinematic%20photography%2C%20deep%20shadows%2C%20ultra%20realistic&width=800&height=600&seq=wmm-r36-2013&orientation=landscape',
    images: [
      'https://readdy.ai/api/search-image?query=luxury%20resort%20hotel%204%20floors%20basement%20exterior%20night%20view%20Bali%2C%20warm%20amber%20facade%20lighting%2C%20dark%20dramatic%20sky%2C%20Balinese%20luxury%20resort%20architecture%2C%20moody%20cinematic%20photography%2C%20deep%20shadows%2C%20ultra%20realistic&width=800&height=600&seq=wmm-r36-2013&orientation=landscape',
    ],
    client: 'PT Bali Persada Nusantara',
    value: 'Rp 44.550.000.000,-',
  },
  {
    id: 37,
    name: 'Pabrik Fidmill Grobogan',
    buildingType: 'Pabrik',
    location: 'Grobogan, Jawa Tengah',
    year: 2013,
    status: 'Selesai',
    workPackage: 'Struktur dan Arsitektur',
    buildingArea: '26.000 m²',
    description: 'Pembangunan Pabrik Fidmill Grobogan seluas 26.000 m² mencakup pekerjaan struktur baja dan beton serta arsitektur untuk fasilitas produksi pakan ternak skala besar di Jawa Tengah.',
    image: 'https://readdy.ai/api/search-image?query=large%20industrial%20factory%20building%20exterior%20night%20view%20Grobogan%20Central%20Java%2C%20warm%20amber%20facade%20lighting%2C%20dark%20dramatic%20sky%2C%20steel%20structure%20industrial%20architecture%2C%20moody%20cinematic%20photography%2C%20deep%20shadows%2C%20ultra%20realistic&width=800&height=600&seq=wmm-r37-2013&orientation=landscape',
    images: [
      'https://readdy.ai/api/search-image?query=large%20industrial%20factory%20building%20exterior%20night%20view%20Grobogan%20Central%20Java%2C%20warm%20amber%20facade%20lighting%2C%20dark%20dramatic%20sky%2C%20steel%20structure%20industrial%20architecture%2C%20moody%20cinematic%20photography%2C%20deep%20shadows%2C%20ultra%20realistic&width=800&height=600&seq=wmm-r37-2013&orientation=landscape',
    ],
    client: 'PT Malindo Fidmill Tbk',
    value: 'Rp 67.650.000.000,-',
  },
  {
    id: 38,
    name: 'Hotel Premier Inn Puri Gading Jimbaran',
    buildingType: 'Hotel',
    location: 'Jimbaran, Bali',
    year: 2013,
    status: 'Selesai',
    workPackage: 'Struktur, Arsitektur dan Plumbing',
    floors: '4 Lantai + 1 Basement',
    buildingArea: '5.400 m²',
    description: 'Pembangunan Hotel Premier Inn Puri Gading Jimbaran Bali 4 lantai dengan 1 basement seluas 5.400 m², mencakup pekerjaan struktur, arsitektur, dan plumbing untuk hotel bintang empat internasional.',
    image: 'https://readdy.ai/api/search-image?query=international%20hotel%204%20floors%20basement%20exterior%20night%20view%20Jimbaran%20Bali%2C%20warm%20amber%20facade%20lighting%2C%20dark%20dramatic%20sky%2C%20Balinese%20modern%20architecture%2C%20moody%20cinematic%20photography%2C%20deep%20shadows%2C%20ultra%20realistic&width=800&height=600&seq=wmm-r38-2013&orientation=landscape',
    images: [
      'https://readdy.ai/api/search-image?query=international%20hotel%204%20floors%20basement%20exterior%20night%20view%20Jimbaran%20Bali%2C%20warm%20amber%20facade%20lighting%2C%20dark%20dramatic%20sky%2C%20Balinese%20modern%20architecture%2C%20moody%20cinematic%20photography%2C%20deep%20shadows%2C%20ultra%20realistic&width=800&height=600&seq=wmm-r38-2013&orientation=landscape',
    ],
    client: 'PT Alda Bali Indotel',
    value: 'Rp 23.900.000.000,-',
  },
  {
    id: 39,
    name: 'Hotel Bedrock Jl. Wanasegara',
    buildingType: 'Hotel',
    location: 'Jl. Wanasegara, Bali',
    year: 2013,
    status: 'Selesai',
    workPackage: 'Struktur, Arsitektur dan Plumbing',
    floors: '4 Lantai + 1 Basement',
    buildingArea: '7.900 m²',
    description: 'Pembangunan Hotel Bedrock Bali 4 lantai dengan 1 basement seluas 7.900 m², mencakup pekerjaan struktur, arsitektur, dan plumbing untuk hotel bintang empat dengan konsep rock and roll Bali.',
    image: 'https://readdy.ai/api/search-image?query=boutique%20hotel%204%20floors%20basement%20exterior%20night%20view%20Bali%20Wanasegara%2C%20warm%20amber%20facade%20lighting%2C%20dark%20dramatic%20sky%2C%20unique%20modern%20Balinese%20architecture%2C%20moody%20cinematic%20photography%2C%20deep%20shadows%2C%20ultra%20realistic&width=800&height=600&seq=wmm-r39-2013&orientation=landscape',
    images: [
      'https://readdy.ai/api/search-image?query=boutique%20hotel%204%20floors%20basement%20exterior%20night%20view%20Bali%20Wanasegara%2C%20warm%20amber%20facade%20lighting%2C%20dark%20dramatic%20sky%2C%20unique%20modern%20Balinese%20architecture%2C%20moody%20cinematic%20photography%2C%20deep%20shadows%2C%20ultra%20realistic&width=800&height=600&seq=wmm-r39-2013&orientation=landscape',
    ],
    client: 'PT Bumi Bali Agung',
    value: 'Rp 37.500.000.000,-',
  },
  {
    id: 40,
    name: 'Springhill Terrace Residence',
    buildingType: 'Apartemen',
    location: 'Jakarta',
    year: 2013,
    status: 'Selesai',
    workPackage: 'Struktur, Arsitektur dan Plumbing',
    floors: '27 Lantai + 1 Basement',
    buildingArea: '72.000 m²',
    description: 'Pembangunan Springhill Terrace Residence 27 lantai dengan 1 basement seluas 72.000 m², mencakup pekerjaan struktur, arsitektur, dan plumbing untuk hunian vertikal premium skala besar di Jakarta.',
    image: 'https://readdy.ai/api/search-image?query=luxury%20high%20rise%20residential%20tower%2027%20floors%20exterior%20night%20view%20Jakarta%2C%20warm%20amber%20facade%20lighting%2C%20dark%20dramatic%20sky%2C%20premium%20modern%20architecture%2C%20moody%20cinematic%20photography%2C%20deep%20shadows%2C%20ultra%20realistic&width=800&height=600&seq=wmm-r40-2013&orientation=landscape',
    images: [
      'https://readdy.ai/api/search-image?query=luxury%20high%20rise%20residential%20tower%2027%20floors%20exterior%20night%20view%20Jakarta%2C%20warm%20amber%20facade%20lighting%2C%20dark%20dramatic%20sky%2C%20premium%20modern%20architecture%2C%20moody%20cinematic%20photography%2C%20deep%20shadows%2C%20ultra%20realistic&width=800&height=600&seq=wmm-r40-2013&orientation=landscape',
    ],
    client: 'PT Graha Cipta Propertindo',
    value: 'Rp 241.000.000.000,-',
  },
  {
    id: 41,
    name: 'Hotel Fave Palembang',
    buildingType: 'Hotel',
    location: 'Palembang, Sumatera Selatan',
    year: 2013,
    status: 'Selesai',
    workPackage: 'Struktur dan Arsitektur',
    floors: '7 Lantai + 1 Basement',
    buildingArea: '8.560 m²',
    description: 'Pembangunan Hotel Fave Palembang 7 lantai dengan 1 basement seluas 8.560 m², mencakup pekerjaan struktur beton bertulang dan arsitektur eksterior-interior hotel bintang tiga modern di Palembang.',
    image: 'https://readdy.ai/api/search-image?query=modern%20hotel%20building%207%20floors%20basement%20exterior%20night%20view%20Palembang%2C%20warm%20amber%20facade%20lighting%2C%20dark%20dramatic%20sky%2C%20contemporary%20architecture%2C%20moody%20cinematic%20photography%2C%20deep%20shadows%2C%20ultra%20realistic&width=800&height=600&seq=wmm-r41-2013&orientation=landscape',
    images: [
      'https://readdy.ai/api/search-image?query=modern%20hotel%20building%207%20floors%20basement%20exterior%20night%20view%20Palembang%2C%20warm%20amber%20facade%20lighting%2C%20dark%20dramatic%20sky%2C%20contemporary%20architecture%2C%20moody%20cinematic%20photography%2C%20deep%20shadows%2C%20ultra%20realistic&width=800&height=600&seq=wmm-r41-2013&orientation=landscape',
    ],
    client: 'PT Mega Central Hotel',
    value: 'Rp 31.640.823.000,-',
  },

  // ─── 2014 ───
  {
    id: 42,
    name: 'Hotel Graha Cakra Malang',
    buildingType: 'Hotel',
    location: 'Malang, Jawa Timur',
    year: 2014,
    status: 'Selesai',
    workPackage: 'Struktur Gedung 1 dan Renovasi Bathroom Gedung 2',
    description: 'Pekerjaan struktur Gedung 1 dan renovasi bathroom Gedung 2 Hotel Graha Cakra Malang, mencakup pembangunan struktur beton bertulang dan renovasi fasilitas kamar mandi hotel.',
    image: 'https://readdy.ai/api/search-image?query=hotel%20building%20construction%20renovation%20exterior%20night%20view%20Malang%20East%20Java%2C%20warm%20amber%20facade%20lighting%2C%20dark%20dramatic%20sky%2C%20modern%20architecture%2C%20moody%20cinematic%20photography%2C%20deep%20shadows%2C%20ultra%20realistic&width=800&height=600&seq=wmm-r42-2014&orientation=landscape',
    images: [
      'https://readdy.ai/api/search-image?query=hotel%20building%20construction%20renovation%20exterior%20night%20view%20Malang%20East%20Java%2C%20warm%20amber%20facade%20lighting%2C%20dark%20dramatic%20sky%2C%20modern%20architecture%2C%20moody%20cinematic%20photography%2C%20deep%20shadows%2C%20ultra%20realistic&width=800&height=600&seq=wmm-r42-2014&orientation=landscape',
    ],
    client: 'PT Cakra Nur Lestari',
    value: 'Rp 5.983.714.000,-',
  },

  // ─── 2015 ───
  {
    id: 43,
    name: 'Hotel Amaris Pluit',
    buildingType: 'Hotel',
    location: 'Pluit, Jakarta Utara',
    year: 2015,
    status: 'Selesai',
    workPackage: 'Struktur, Arsitektur dan Plumbing',
    floors: '8 Lantai + 1 Basement',
    buildingArea: '4.800 m²',
    description: 'Pembangunan Hotel Amaris Pluit 8 lantai dengan 1 basement seluas 4.800 m², mencakup pekerjaan struktur beton bertulang, arsitektur eksterior-interior, dan sistem plumbing lengkap untuk hotel bintang tiga.',
    image: 'https://readdy.ai/api/search-image?query=modern%20hotel%20building%208%20floors%20basement%20exterior%20night%20view%20Pluit%20Jakarta%20Utara%2C%20warm%20amber%20facade%20lighting%2C%20dark%20dramatic%20sky%2C%20contemporary%20architecture%2C%20moody%20cinematic%20photography%2C%20deep%20shadows%2C%20ultra%20realistic&width=800&height=600&seq=wmm-r43-2015&orientation=landscape',
    images: [
      'https://readdy.ai/api/search-image?query=modern%20hotel%20building%208%20floors%20basement%20exterior%20night%20view%20Pluit%20Jakarta%20Utara%2C%20warm%20amber%20facade%20lighting%2C%20dark%20dramatic%20sky%2C%20contemporary%20architecture%2C%20moody%20cinematic%20photography%2C%20deep%20shadows%2C%20ultra%20realistic&width=800&height=600&seq=wmm-r43-2015&orientation=landscape',
    ],
    client: 'PT Sumber Mitra Bahagia',
    value: 'Rp 27.000.000.000,-',
  },
  {
    id: 44,
    name: 'Condotel Springhill Lampung',
    buildingType: 'Apartemen',
    location: 'Lampung',
    year: 2015,
    status: 'Selesai',
    workPackage: 'Struktur, Arsitektur dan Plumbing',
    floors: '18 Lantai + 1 Basement',
    buildingArea: '37.800 m²',
    description: 'Pembangunan Condotel Springhill Lampung 18 lantai dengan 1 basement seluas 37.800 m², mencakup pekerjaan struktur, arsitektur, dan plumbing untuk hunian vertikal premium skala besar di Lampung.',
    image: 'https://readdy.ai/api/search-image?query=tall%20condotel%20building%2018%20floors%20basement%20exterior%20night%20view%20Lampung%2C%20warm%20amber%20facade%20lighting%2C%20dark%20dramatic%20sky%2C%20premium%20modern%20architecture%2C%20moody%20cinematic%20photography%2C%20deep%20shadows%2C%20ultra%20realistic&width=800&height=600&seq=wmm-r44-2015&orientation=landscape',
    images: [
      'https://readdy.ai/api/search-image?query=tall%20condotel%20building%2018%20floors%20basement%20exterior%20night%20view%20Lampung%2C%20warm%20amber%20facade%20lighting%2C%20dark%20dramatic%20sky%2C%20premium%20modern%20architecture%2C%20moody%20cinematic%20photography%2C%20deep%20shadows%2C%20ultra%20realistic&width=800&height=600&seq=wmm-r44-2015&orientation=landscape',
    ],
    client: 'PT Bukit Berkat Propertindo',
    value: 'Rp 128.000.000.000,-',
  },

  // ─── 2016 ───
  {
    id: 45,
    name: 'Apartemen Foresque',
    buildingType: 'Apartemen',
    location: 'Jakarta',
    year: 2016,
    status: 'Selesai',
    workPackage: 'Struktur, Arsitektur dan Plumbing',
    floors: '27 Lantai + 3 Basement',
    description: 'Pembangunan Apartemen Foresque 27 lantai dengan 3 basement, mencakup pekerjaan struktur beton bertulang, arsitektur eksterior-interior, dan sistem plumbing lengkap untuk hunian vertikal premium skala besar.',
    image: 'https://readdy.ai/api/search-image?query=luxury%20apartment%20tower%2027%20floors%203%20basement%20exterior%20night%20view%20Jakarta%2C%20warm%20amber%20facade%20lighting%2C%20dark%20dramatic%20sky%2C%20premium%20high%20rise%20architecture%2C%20moody%20cinematic%20photography%2C%20deep%20shadows%2C%20ultra%20realistic&width=800&height=600&seq=wmm-r45-2016&orientation=landscape',
    images: [
      'https://readdy.ai/api/search-image?query=luxury%20apartment%20tower%2027%20floors%203%20basement%20exterior%20night%20view%20Jakarta%2C%20warm%20amber%20facade%20lighting%2C%20dark%20dramatic%20sky%2C%20premium%20high%20rise%20architecture%2C%20moody%20cinematic%20photography%2C%20deep%20shadows%2C%20ultra%20realistic&width=800&height=600&seq=wmm-r45-2016&orientation=landscape',
    ],
    client: 'PT Griya Karunia Sejahtera',
    value: 'Rp 225.375.700.000,-',
  },
  {
    id: 46,
    name: 'The Wiladatika Residence Cibubur Tahap 1',
    buildingType: 'Perumahan',
    location: 'Cibubur, Jakarta Timur',
    year: 2016,
    status: 'Selesai',
    workPackage: 'Struktur, Arsitektur dan MEP',
    description: 'Pekerjaan Struktur, Arsitektur dan MEP The Wiladatika Residence Cibubur Tahap 1, mencakup pembangunan hunian residensial premium dengan sistem mekanikal, elektrikal, dan plumbing terintegrasi.',
    image: 'https://readdy.ai/api/search-image?query=premium%20residential%20complex%20construction%20Cibubur%20Jakarta%2C%20modern%20houses%20concrete%20structure%2C%20warm%20amber%20work%20lights%20dusk%2C%20dark%20dramatic%20sky%2C%20professional%20architectural%20photography%2C%20deep%20shadows%2C%20cinematic%20moody%20atmosphere%2C%20ultra%20realistic&width=800&height=600&seq=wmm-r46-2016&orientation=landscape',
    images: [
      'https://readdy.ai/api/search-image?query=premium%20residential%20complex%20construction%20Cibubur%20Jakarta%2C%20modern%20houses%20concrete%20structure%2C%20warm%20amber%20work%20lights%20dusk%2C%20dark%20dramatic%20sky%2C%20professional%20architectural%20photography%2C%20deep%20shadows%2C%20cinematic%20moody%20atmosphere%2C%20ultra%20realistic&width=800&height=600&seq=wmm-r46-2016&orientation=landscape',
    ],
    client: 'PT. Bahana Tirta Adhiguna',
    value: 'Rp 38.105.078.000,-',
  },

  // ─── 2017 ───
  {
    id: 47,
    name: 'Hotel Harpper Palembang',
    buildingType: 'Hotel',
    location: 'Palembang, Sumatera Selatan',
    year: 2017,
    status: 'Selesai',
    workPackage: 'Struktur, Arsitektur dan Plumbing',
    floors: '10 Lantai + 1 Basement',
    buildingArea: '7.500 m²',
    description: 'Pembangunan Hotel Harpper Palembang 10 lantai dengan 1 basement seluas 7.500 m², mencakup pekerjaan struktur beton bertulang, arsitektur eksterior-interior, dan sistem plumbing lengkap untuk hotel bintang empat.',
    image: 'https://readdy.ai/api/search-image?query=modern%20hotel%20building%2010%20floors%20basement%20exterior%20night%20view%20Palembang%2C%20warm%20amber%20facade%20lighting%2C%20dark%20dramatic%20sky%2C%20contemporary%20architecture%2C%20moody%20cinematic%20photography%2C%20deep%20shadows%2C%20ultra%20realistic&width=800&height=600&seq=wmm-r47-2017&orientation=landscape',
    images: [
      'https://readdy.ai/api/search-image?query=modern%20hotel%20building%2010%20floors%20basement%20exterior%20night%20view%20Palembang%2C%20warm%20amber%20facade%20lighting%2C%20dark%20dramatic%20sky%2C%20contemporary%20architecture%2C%20moody%20cinematic%20photography%2C%20deep%20shadows%2C%20ultra%20realistic&width=800&height=600&seq=wmm-r47-2017&orientation=landscape',
    ],
    client: 'PT Prime Central Hotel',
    value: 'Rp 76.221.000.000,-',
  },
  {
    id: 48,
    name: 'The Wiladatika Residence Cibubur Tahap 2',
    buildingType: 'Perumahan',
    location: 'Cibubur, Jakarta Timur',
    year: 2017,
    status: 'Selesai',
    workPackage: 'Struktur, Arsitektur dan MEP',
    description: 'Pekerjaan Struktur, Arsitektur dan MEP The Wiladatika Residence Cibubur Tahap 2, melanjutkan pembangunan hunian residensial premium dengan sistem MEP terintegrasi.',
    image: 'https://readdy.ai/api/search-image?query=premium%20residential%20complex%20phase%202%20construction%20Cibubur%20Jakarta%2C%20modern%20houses%20concrete%20structure%2C%20warm%20amber%20work%20lights%20dusk%2C%20dark%20dramatic%20sky%2C%20professional%20architectural%20photography%2C%20deep%20shadows%2C%20cinematic%20moody%20atmosphere%2C%20ultra%20realistic&width=800&height=600&seq=wmm-r48-2017&orientation=landscape',
    images: [
      'https://readdy.ai/api/search-image?query=premium%20residential%20complex%20phase%202%20construction%20Cibubur%20Jakarta%2C%20modern%20houses%20concrete%20structure%2C%20warm%20amber%20work%20lights%20dusk%2C%20dark%20dramatic%20sky%2C%20professional%20architectural%20photography%2C%20deep%20shadows%2C%20cinematic%20moody%20atmosphere%2C%20ultra%20realistic&width=800&height=600&seq=wmm-r48-2017&orientation=landscape',
    ],
    client: 'PT. Bahana Tirta Adhiguna',
    value: 'Rp 13.911.080.000,-',
  },

  // ─── 2018 ───
  {
    id: 49,
    name: 'The Wiladatika Residence Cibubur Tahap 3',
    buildingType: 'Perumahan',
    location: 'Cibubur, Jakarta Timur',
    year: 2018,
    status: 'Selesai',
    workPackage: 'Struktur, Arsitektur dan MEP',
    description: 'Pekerjaan Struktur, Arsitektur dan MEP The Wiladatika Residence Cibubur Tahap 3, penyelesaian akhir pembangunan hunian residensial premium dengan sistem MEP terintegrasi.',
    image: 'https://readdy.ai/api/search-image?query=premium%20residential%20complex%20phase%203%20completion%20Cibubur%20Jakarta%2C%20modern%20houses%20finished%20construction%2C%20warm%20amber%20lights%20dusk%2C%20dark%20dramatic%20sky%2C%20professional%20architectural%20photography%2C%20deep%20shadows%2C%20cinematic%20moody%20atmosphere%2C%20ultra%20realistic&width=800&height=600&seq=wmm-r49-2018&orientation=landscape',
    images: [
      'https://readdy.ai/api/search-image?query=premium%20residential%20complex%20phase%203%20completion%20Cibubur%20Jakarta%2C%20modern%20houses%20finished%20construction%2C%20warm%20amber%20lights%20dusk%2C%20dark%20dramatic%20sky%2C%20professional%20architectural%20photography%2C%20deep%20shadows%2C%20cinematic%20moody%20atmosphere%2C%20ultra%20realistic&width=800&height=600&seq=wmm-r49-2018&orientation=landscape',
    ],
    client: 'PT. Bahana Tirta Adhiguna',
    value: 'Rp 15.239.370.000,-',
  },
  {
    id: 50,
    name: 'Hotel Discovery Ancol',
    buildingType: 'Hotel',
    location: 'Ancol, Jakarta Utara',
    year: 2018,
    status: 'Selesai',
    workPackage: 'Struktur dan Arsitektur',
    description: 'Pembangunan Hotel Discovery Ancol mencakup pekerjaan struktur beton bertulang dan arsitektur eksterior-interior hotel di kawasan wisata Ancol Jakarta Utara.',
    image: 'https://readdy.ai/api/search-image?query=modern%20hotel%20building%20exterior%20night%20view%20Ancol%20Jakarta%20Utara%2C%20warm%20amber%20facade%20lighting%2C%20dark%20dramatic%20sky%2C%20waterfront%20hotel%20architecture%2C%20moody%20cinematic%20photography%2C%20deep%20shadows%2C%20ultra%20realistic&width=800&height=600&seq=wmm-r50-2018&orientation=landscape',
    images: [
      'https://readdy.ai/api/search-image?query=modern%20hotel%20building%20exterior%20night%20view%20Ancol%20Jakarta%20Utara%2C%20warm%20amber%20facade%20lighting%2C%20dark%20dramatic%20sky%2C%20waterfront%20hotel%20architecture%2C%20moody%20cinematic%20photography%2C%20deep%20shadows%2C%20ultra%20realistic&width=800&height=600&seq=wmm-r50-2018&orientation=landscape',
    ],
    client: 'PT. Marina Ancol Green Hotel',
    value: 'Rp 8.976.072.000,-',
  },

  // ─── 2019 ───
  {
    id: 51,
    name: 'Citimall Cianjur',
    buildingType: 'Mall',
    location: 'Cianjur, Jawa Barat',
    year: 2019,
    status: 'Selesai',
    workPackage: 'Pondasi, Struktur, Arsitektur dan Facade',
    floors: '4 Lantai + 2 Basement',
    buildingArea: '22.800 m²',
    description: 'Pembangunan Citimall Cianjur 4 lantai dengan 2 basement seluas 22.800 m², mencakup pekerjaan pondasi, struktur, arsitektur, dan facade untuk pusat perbelanjaan modern di Cianjur.',
    image: 'https://readdy.ai/api/search-image?query=modern%20shopping%20mall%204%20floors%20basement%20exterior%20night%20view%20Cianjur%20West%20Java%2C%20warm%20amber%20facade%20lighting%2C%20dark%20dramatic%20sky%2C%20commercial%20architecture%2C%20moody%20cinematic%20photography%2C%20deep%20shadows%2C%20ultra%20realistic&width=800&height=600&seq=wmm-r51-2019&orientation=landscape',
    images: [
      'https://readdy.ai/api/search-image?query=modern%20shopping%20mall%204%20floors%20basement%20exterior%20night%20view%20Cianjur%20West%20Java%2C%20warm%20amber%20facade%20lighting%2C%20dark%20dramatic%20sky%2C%20commercial%20architecture%2C%20moody%20cinematic%20photography%2C%20deep%20shadows%2C%20ultra%20realistic&width=800&height=600&seq=wmm-r51-2019&orientation=landscape',
    ],
    client: 'PT. Nirvana Wastu Pratama',
    value: 'Rp 73.700.000.000,-',
  },
  {
    id: 52,
    name: 'Ruko Grand Taruma City Karawang Tahap 1',
    buildingType: 'Ruko',
    location: 'Karawang, Jawa Barat',
    year: 2019,
    status: 'Selesai',
    workPackage: 'Struktur, Arsitektur dan MEP',
    unitCount: '58 Unit',
    buildingArea: '18.745 m²',
    description: 'Pembangunan Ruko Grand Taruma City Karawang Tahap 1 sebanyak 58 unit seluas 18.745 m², mencakup pekerjaan struktur, arsitektur, dan MEP lengkap untuk kawasan komersial modern.',
    image: 'https://readdy.ai/api/search-image?query=modern%20shophouse%20commercial%20complex%2058%20units%20exterior%20night%20view%20Karawang%20West%20Java%2C%20warm%20amber%20facade%20lighting%2C%20dark%20dramatic%20sky%2C%20contemporary%20commercial%20architecture%2C%20moody%20cinematic%20photography%2C%20deep%20shadows%2C%20ultra%20realistic&width=800&height=600&seq=wmm-r52-2019&orientation=landscape',
    images: [
      'https://readdy.ai/api/search-image?query=modern%20shophouse%20commercial%20complex%2058%20units%20exterior%20night%20view%20Karawang%20West%20Java%2C%20warm%20amber%20facade%20lighting%2C%20dark%20dramatic%20sky%2C%20contemporary%20commercial%20architecture%2C%20moody%20cinematic%20photography%2C%20deep%20shadows%2C%20ultra%20realistic&width=800&height=600&seq=wmm-r52-2019&orientation=landscape',
    ],
    client: 'PT. Tatar Kertabumi (APL Group)',
    value: 'Rp 67.150.000.000,-',
  },
  {
    id: 53,
    name: 'Cluster Hickory Podomoro Golf View Cimanggis',
    buildingType: 'Perumahan Cluster',
    location: 'Cimanggis, Depok',
    year: 2019,
    status: 'Selesai',
    workPackage: 'Struktur, Arsitektur dan MEP',
    unitCount: '38 Unit',
    description: 'Pembangunan Cluster Hickory Perumahan Podomoro Golf View Cimanggis sebanyak 38 unit, mencakup pekerjaan struktur, arsitektur, dan MEP lengkap untuk hunian premium di kawasan golf.',
    image: 'https://readdy.ai/api/search-image?query=premium%20residential%20cluster%2038%20units%20golf%20view%20Cimanggis%20Depok%2C%20modern%20houses%20concrete%20structure%2C%20warm%20amber%20lights%20dusk%2C%20dark%20dramatic%20sky%2C%20professional%20architectural%20photography%2C%20deep%20shadows%2C%20cinematic%20moody%20atmosphere%2C%20ultra%20realistic&width=800&height=600&seq=wmm-r53-2019&orientation=landscape',
    images: [
      'https://readdy.ai/api/search-image?query=premium%20residential%20cluster%2038%20units%20golf%20view%20Cimanggis%20Depok%2C%20modern%20houses%20concrete%20structure%2C%20warm%20amber%20lights%20dusk%2C%20dark%20dramatic%20sky%2C%20professional%20architectural%20photography%2C%20deep%20shadows%2C%20cinematic%20moody%20atmosphere%2C%20ultra%20realistic&width=800&height=600&seq=wmm-r53-2019&orientation=landscape',
    ],
    client: 'PT. Graha Tunas Selaras (APL Group)',
    value: 'Rp 24.663.213.352,-',
  },

  // ─── 2020 ───
  {
    id: 54,
    name: 'Cluster Iroko Podomoro Golf View Cimanggis',
    buildingType: 'Perumahan Cluster',
    location: 'Cimanggis, Depok',
    year: 2020,
    status: 'Selesai',
    workPackage: 'Struktur, Arsitektur dan MEP',
    unitCount: '52 Unit',
    description: 'Pembangunan Cluster Iroko Perumahan Podomoro Golf View Cimanggis sebanyak 52 unit, mencakup pekerjaan struktur, arsitektur, dan MEP lengkap untuk hunian premium di kawasan golf.',
    image: 'https://readdy.ai/api/search-image?query=premium%20residential%20cluster%2052%20units%20golf%20view%20Cimanggis%20Depok%20phase%202%2C%20modern%20houses%20concrete%20structure%2C%20warm%20amber%20lights%20dusk%2C%20dark%20dramatic%20sky%2C%20professional%20architectural%20photography%2C%20deep%20shadows%2C%20cinematic%20moody%20atmosphere%2C%20ultra%20realistic&width=800&height=600&seq=wmm-r54-2020&orientation=landscape',
    images: [
      'https://readdy.ai/api/search-image?query=premium%20residential%20cluster%2052%20units%20golf%20view%20Cimanggis%20Depok%20phase%202%2C%20modern%20houses%20concrete%20structure%2C%20warm%20amber%20lights%20dusk%2C%20dark%20dramatic%20sky%2C%20professional%20architectural%20photography%2C%20deep%20shadows%2C%20cinematic%20moody%20atmosphere%2C%20ultra%20realistic&width=800&height=600&seq=wmm-r54-2020&orientation=landscape',
    ],
    client: 'PT. Graha Tunas Selaras (APL Group)',
    value: 'Rp 40.120.092.581,-',
  },
  {
    id: 55,
    name: 'Infrastruktur Kota Kertabumi Tahap 1',
    buildingType: 'Infrastruktur',
    location: 'Karawang, Jawa Barat',
    year: 2020,
    status: 'Selesai',
    workPackage: 'Infrastruktur',
    description: 'Pekerjaan infrastruktur Kota Kertabumi Tahap 1 di Karawang, mencakup pembangunan infrastruktur dasar kawasan kota baru meliputi jalan, drainase, dan utilitas.',
    image: 'https://readdy.ai/api/search-image?query=urban%20infrastructure%20construction%20site%20Karawang%20West%20Java%2C%20road%20drainage%20construction%2C%20warm%20amber%20work%20lights%20dusk%2C%20dark%20dramatic%20sky%2C%20professional%20construction%20photography%2C%20deep%20shadows%2C%20cinematic%20moody%20atmosphere%2C%20ultra%20realistic&width=800&height=600&seq=wmm-r55-2020&orientation=landscape',
    images: [
      'https://readdy.ai/api/search-image?query=urban%20infrastructure%20construction%20site%20Karawang%20West%20Java%2C%20road%20drainage%20construction%2C%20warm%20amber%20work%20lights%20dusk%2C%20dark%20dramatic%20sky%2C%20professional%20construction%20photography%2C%20deep%20shadows%2C%20cinematic%20moody%20atmosphere%2C%20ultra%20realistic&width=800&height=600&seq=wmm-r55-2020&orientation=landscape',
    ],
    client: 'PT. Tatar Kertabumi (APL Group)',
    value: 'Rp 8.635.000.000,-',
  },
  {
    id: 56,
    name: 'Marketing Gallery Podomoro Park Bandung',
    buildingType: 'Marketing Gallery',
    location: 'Bandung, Jawa Barat',
    year: 2020,
    status: 'Selesai',
    workPackage: 'Arsitektur dan MEP',
    description: 'Pekerjaan arsitektur dan MEP Marketing Gallery Podomoro Park Bandung, mencakup desain dan pelaksanaan arsitektur interior-eksterior serta sistem MEP untuk galeri pemasaran properti premium.',
    image: 'https://readdy.ai/api/search-image?query=modern%20marketing%20gallery%20building%20exterior%20night%20view%20Bandung%2C%20warm%20amber%20facade%20lighting%2C%20dark%20dramatic%20sky%2C%20contemporary%20architecture%2C%20moody%20cinematic%20photography%2C%20deep%20shadows%2C%20ultra%20realistic&width=800&height=600&seq=wmm-r56-2020&orientation=landscape',
    images: [
      'https://readdy.ai/api/search-image?query=modern%20marketing%20gallery%20building%20exterior%20night%20view%20Bandung%2C%20warm%20amber%20facade%20lighting%2C%20dark%20dramatic%20sky%2C%20contemporary%20architecture%2C%20moody%20cinematic%20photography%2C%20deep%20shadows%2C%20ultra%20realistic&width=800&height=600&seq=wmm-r56-2020&orientation=landscape',
    ],
    client: 'PT. Pesona Mitra Kembar Mas (APL Group)',
    value: 'Rp 10.500.000.000,-',
  },

  // ─── 2021 ───
  {
    id: 57,
    name: 'Rumah Kel. Bpk Indra Wibisana Palembang',
    buildingType: 'Lainnya',
    location: 'Palembang, Sumatera Selatan',
    year: 2021,
    status: 'Selesai',
    workPackage: 'Struktur, Arsitektur dan MEP',
    buildingArea: '2.600 m²',
    description: 'Pembangunan rumah keluarga Bpk Indra Wibisana di Palembang seluas 2.600 m², mencakup pekerjaan struktur, arsitektur, dan MEP lengkap untuk hunian mewah private.',
    image: 'https://readdy.ai/api/search-image?query=luxury%20private%20mansion%20house%20exterior%20night%20view%20Palembang%2C%20warm%20amber%20facade%20lighting%2C%20dark%20dramatic%20sky%2C%20premium%20residential%20architecture%2C%20moody%20cinematic%20photography%2C%20deep%20shadows%2C%20ultra%20realistic&width=800&height=600&seq=wmm-r57-2021&orientation=landscape',
    images: [
      'https://readdy.ai/api/search-image?query=luxury%20private%20mansion%20house%20exterior%20night%20view%20Palembang%2C%20warm%20amber%20facade%20lighting%2C%20dark%20dramatic%20sky%2C%20premium%20residential%20architecture%2C%20moody%20cinematic%20photography%2C%20deep%20shadows%2C%20ultra%20realistic&width=800&height=600&seq=wmm-r57-2021&orientation=landscape',
    ],
    client: 'PT. Grand Central Hotel',
    value: 'Rp 25.950.000.000,-',
  },
  {
    id: 58,
    name: 'Hotel Ibis Palembang',
    buildingType: 'Hotel',
    location: 'Palembang, Sumatera Selatan',
    year: 2021,
    status: 'Selesai',
    workPackage: 'Struktur dan Arsitektur',
    floors: '1 Basement + 10 Lantai',
    buildingArea: '8.900 m²',
    description: 'Pembangunan Hotel Ibis Palembang 1 basement + 10 lantai seluas 8.900 m², mencakup pekerjaan struktur beton bertulang dan arsitektur eksterior-interior hotel bintang tiga internasional.',
    image: 'https://readdy.ai/api/search-image?query=modern%20Ibis%20hotel%20building%2010%20floors%20basement%20exterior%20night%20view%20Palembang%2C%20warm%20amber%20facade%20lighting%2C%20dark%20dramatic%20sky%2C%20international%20hotel%20architecture%2C%20moody%20cinematic%20photography%2C%20deep%20shadows%2C%20ultra%20realistic&width=800&height=600&seq=wmm-r58-2021&orientation=landscape',
    images: [
      'https://readdy.ai/api/search-image?query=modern%20Ibis%20hotel%20building%2010%20floors%20basement%20exterior%20night%20view%20Palembang%2C%20warm%20amber%20facade%20lighting%2C%20dark%20dramatic%20sky%2C%20international%20hotel%20architecture%2C%20moody%20cinematic%20photography%2C%20deep%20shadows%2C%20ultra%20realistic&width=800&height=600&seq=wmm-r58-2021&orientation=landscape',
    ],
    client: 'PT. Indo Citra Mulia',
    value: 'Rp 32.450.000.000,-',
  },
  {
    id: 59,
    name: 'Palembang Indah Mall',
    buildingType: 'Mall',
    location: 'Palembang, Sumatera Selatan',
    year: 2021,
    status: 'Selesai',
    workPackage: 'Renovasi Struktur, Arsitektur dan MEP Lt. Dasar',
    buildingArea: '4.600 m²',
    description: 'Pekerjaan renovasi struktur, arsitektur, dan MEP Palembang Indah Mall pada lantai dasar seluas 4.600 m², mencakup pembaruan fasilitas dan tampilan pusat perbelanjaan terkemuka di Palembang.',
    image: 'https://readdy.ai/api/search-image?query=shopping%20mall%20renovation%20interior%20Palembang%2C%20modern%20retail%20space%20warm%20amber%20lighting%2C%20dark%20dramatic%20atmosphere%2C%20commercial%20renovation%20photography%2C%20deep%20shadows%2C%20cinematic%20moody%20atmosphere%2C%20ultra%20realistic&width=800&height=600&seq=wmm-r59-2021&orientation=landscape',
    images: [
      'https://readdy.ai/api/search-image?query=shopping%20mall%20renovation%20interior%20Palembang%2C%20modern%20retail%20space%20warm%20amber%20lighting%2C%20dark%20dramatic%20atmosphere%2C%20commercial%20renovation%20photography%2C%20deep%20shadows%2C%20cinematic%20moody%20atmosphere%2C%20ultra%20realistic&width=800&height=600&seq=wmm-r59-2021&orientation=landscape',
    ],
    client: 'PT. Indo Citra Mulia',
    value: 'Rp 10.650.000.000,-',
  },
  {
    id: 60,
    name: 'Cluster Juniper 2 Podomoro Golf View Cimanggis',
    buildingType: 'Perumahan Cluster',
    location: 'Cimanggis, Depok',
    year: 2021,
    status: 'Selesai',
    workPackage: 'Struktur, Arsitektur dan MEP',
    unitCount: '24 Unit',
    buildingArea: '2.880 m²',
    description: 'Pembangunan Cluster Juniper 2 Perumahan Podomoro Golf View Cimanggis sebanyak 24 unit seluas 2.880 m², mencakup pekerjaan struktur, arsitektur, dan MEP lengkap untuk hunian premium.',
    image: 'https://readdy.ai/api/search-image?query=premium%20residential%20cluster%2024%20units%20golf%20view%20Cimanggis%20Depok%20Juniper%2C%20modern%20houses%20concrete%20structure%2C%20warm%20amber%20lights%20dusk%2C%20dark%20dramatic%20sky%2C%20professional%20architectural%20photography%2C%20deep%20shadows%2C%20cinematic%20moody%20atmosphere%2C%20ultra%20realistic&width=800&height=600&seq=wmm-r60-2021&orientation=landscape',
    images: [
      'https://readdy.ai/api/search-image?query=premium%20residential%20cluster%2024%20units%20golf%20view%20Cimanggis%20Depok%20Juniper%2C%20modern%20houses%20concrete%20structure%2C%20warm%20amber%20lights%20dusk%2C%20dark%20dramatic%20sky%2C%20professional%20architectural%20photography%2C%20deep%20shadows%2C%20cinematic%20moody%20atmosphere%2C%20ultra%20realistic&width=800&height=600&seq=wmm-r60-2021&orientation=landscape',
    ],
    client: 'PT. Graha Tunas Selaras (APL Group)',
    value: 'Rp 20.980.000.000,-',
  },

  // ─── 2022 ───
  {
    id: 61,
    name: 'Kantor Proyek Kota Podomoro Tenjo',
    buildingType: 'Kantor',
    location: 'Tenjo, Bogor',
    year: 2022,
    status: 'Selesai',
    workPackage: 'Struktur, Arsitektur dan MEP',
    buildingArea: '1.400 m²',
    description: 'Pembangunan kantor proyek PT Kota Podomoro Tenjo seluas 1.400 m², mencakup pekerjaan struktur, arsitektur, dan MEP lengkap untuk fasilitas perkantoran proyek.',
    image: 'https://readdy.ai/api/search-image?query=modern%20project%20office%20building%20exterior%20night%20view%20Tenjo%20Bogor%2C%20warm%20amber%20facade%20lighting%2C%20dark%20dramatic%20sky%2C%20contemporary%20architecture%2C%20moody%20cinematic%20photography%2C%20deep%20shadows%2C%20ultra%20realistic&width=800&height=600&seq=wmm-r61-2022&orientation=landscape',
    images: [
      'https://readdy.ai/api/search-image?query=modern%20project%20office%20building%20exterior%20night%20view%20Tenjo%20Bogor%2C%20warm%20amber%20facade%20lighting%2C%20dark%20dramatic%20sky%2C%20contemporary%20architecture%2C%20moody%20cinematic%20photography%2C%20deep%20shadows%2C%20ultra%20realistic&width=800&height=600&seq=wmm-r61-2022&orientation=landscape',
    ],
    client: 'PT. Kota Podomoro Tenjo (APL Group)',
    value: 'Rp 7.900.000.000,-',
  },
  {
    id: 62,
    name: 'Ruko Kayu Manis Blok H dan I Kota Podomoro Tenjo',
    buildingType: 'Ruko',
    location: 'Tenjo, Bogor',
    year: 2022,
    status: 'Selesai',
    workPackage: 'Struktur, Arsitektur dan MEP',
    unitCount: '55 Unit',
    description: 'Pembangunan Ruko Kayu Manis Blok H dan I sebanyak 55 unit di Kota Podomoro Tenjo, mencakup pekerjaan struktur, arsitektur, dan MEP lengkap untuk kawasan komersial modern.',
    image: 'https://readdy.ai/api/search-image?query=modern%20shophouse%20complex%2055%20units%20exterior%20night%20view%20Tenjo%20Bogor%2C%20warm%20amber%20facade%20lighting%2C%20dark%20dramatic%20sky%2C%20contemporary%20commercial%20architecture%2C%20moody%20cinematic%20photography%2C%20deep%20shadows%2C%20ultra%20realistic&width=800&height=600&seq=wmm-r62-2022&orientation=landscape',
    images: [
      'https://readdy.ai/api/search-image?query=modern%20shophouse%20complex%2055%20units%20exterior%20night%20view%20Tenjo%20Bogor%2C%20warm%20amber%20facade%20lighting%2C%20dark%20dramatic%20sky%2C%20contemporary%20commercial%20architecture%2C%20moody%20cinematic%20photography%2C%20deep%20shadows%2C%20ultra%20realistic&width=800&height=600&seq=wmm-r62-2022&orientation=landscape',
    ],
    client: 'PT. Mitra Abadi Utama (APL Group)',
    value: 'Rp 18.267.000.000,-',
  },
  {
    id: 63,
    name: 'Club House dan Musholla Paket 2B Kota Podomoro Tenjo',
    buildingType: 'Club House',
    location: 'Tenjo, Bogor',
    year: 2022,
    status: 'Selesai',
    workPackage: 'Struktur, Arsitektur dan MEP',
    description: 'Pembangunan Club House dan Musholla Paket 2B di Kota Podomoro Tenjo, mencakup pekerjaan struktur, arsitektur, dan MEP lengkap untuk fasilitas komunitas perumahan.',
    image: 'https://readdy.ai/api/search-image?query=modern%20clubhouse%20building%20exterior%20night%20view%20Tenjo%20Bogor%2C%20warm%20amber%20facade%20lighting%2C%20dark%20dramatic%20sky%2C%20contemporary%20architecture%2C%20moody%20cinematic%20photography%2C%20deep%20shadows%2C%20ultra%20realistic&width=800&height=600&seq=wmm-r63-2022&orientation=landscape',
    images: [
      'https://readdy.ai/api/search-image?query=modern%20clubhouse%20building%20exterior%20night%20view%20Tenjo%20Bogor%2C%20warm%20amber%20facade%20lighting%2C%20dark%20dramatic%20sky%2C%20contemporary%20architecture%2C%20moody%20cinematic%20photography%2C%20deep%20shadows%2C%20ultra%20realistic&width=800&height=600&seq=wmm-r63-2022&orientation=landscape',
    ],
    client: 'PT. Mitra Abadi Utama (APL Group)',
    value: 'Rp 3.750.000.000,-',
  },
  {
    id: 64,
    name: 'Cluster Arshana Podomoro Park Bandung',
    buildingType: 'Perumahan Cluster',
    location: 'Bandung, Jawa Barat',
    year: 2022,
    status: 'Selesai',
    workPackage: 'Struktur, Arsitektur dan MEP',
    unitCount: '45 Unit',
    buildingArea: '2.803 m²',
    description: 'Pembangunan Cluster Arshana Podomoro Park Bandung sebanyak 45 unit seluas 2.803 m², mencakup pekerjaan struktur, arsitektur, dan MEP lengkap untuk hunian premium di Bandung.',
    image: 'https://readdy.ai/api/search-image?query=premium%20residential%20cluster%2045%20units%20Podomoro%20Park%20Bandung%2C%20modern%20houses%20concrete%20structure%2C%20warm%20amber%20lights%20dusk%2C%20dark%20dramatic%20sky%2C%20professional%20architectural%20photography%2C%20deep%20shadows%2C%20cinematic%20moody%20atmosphere%2C%20ultra%20realistic&width=800&height=600&seq=wmm-r64-2022&orientation=landscape',
    images: [
      'https://readdy.ai/api/search-image?query=premium%20residential%20cluster%2045%20units%20Podomoro%20Park%20Bandung%2C%20modern%20houses%20concrete%20structure%2C%20warm%20amber%20lights%20dusk%2C%20dark%20dramatic%20sky%2C%20professional%20architectural%20photography%2C%20deep%20shadows%2C%20cinematic%20moody%20atmosphere%2C%20ultra%20realistic&width=800&height=600&seq=wmm-r64-2022&orientation=landscape',
    ],
    client: 'PT. Pesona Mitra Kembar Mas (APL Group)',
    value: 'Rp 16.047.900.000,-',
  },
  {
    id: 65,
    name: 'Ruko Blok E dan F Podomoro Park Bandung',
    buildingType: 'Ruko',
    location: 'Bandung, Jawa Barat',
    year: 2022,
    status: 'Selesai',
    workPackage: 'Struktur, Arsitektur dan MEP',
    unitCount: '22 Unit',
    buildingArea: '3.500 m²',
    description: 'Pembangunan Ruko Blok E dan F Podomoro Park Bandung sebanyak 22 unit seluas 3.500 m², mencakup pekerjaan struktur, arsitektur, dan MEP lengkap untuk kawasan komersial premium.',
    image: 'https://readdy.ai/api/search-image?query=modern%20shophouse%20complex%2022%20units%20Podomoro%20Park%20Bandung%20exterior%20night%20view%2C%20warm%20amber%20facade%20lighting%2C%20dark%20dramatic%20sky%2C%20contemporary%20commercial%20architecture%2C%20moody%20cinematic%20photography%2C%20deep%20shadows%2C%20ultra%20realistic&width=800&height=600&seq=wmm-r65-2022&orientation=landscape',
    images: [
      'https://readdy.ai/api/search-image?query=modern%20shophouse%20complex%2022%20units%20Podomoro%20Park%20Bandung%20exterior%20night%20view%2C%20warm%20amber%20facade%20lighting%2C%20dark%20dramatic%20sky%2C%20contemporary%20commercial%20architecture%2C%20moody%20cinematic%20photography%2C%20deep%20shadows%2C%20ultra%20realistic&width=800&height=600&seq=wmm-r65-2022&orientation=landscape',
    ],
    client: 'PT. Pesona Mitra Kembar Mas (APL Group)',
    value: 'Rp 21.198.000.000,-',
  },

  // ─── 2023 ───
  {
    id: 66,
    name: 'Club House Ridge Crystal Harvest City Cileungsi',
    buildingType: 'Club House',
    location: 'Cileungsi, Bogor',
    year: 2023,
    status: 'Selesai',
    workPackage: 'Struktur, Arsitektur dan MEP',
    buildingArea: '600 m²',
    description: 'Pembangunan Club House Ridge Crystal Harvest City Cileungsi seluas 600 m², mencakup pekerjaan struktur, arsitektur, dan MEP lengkap untuk fasilitas komunitas perumahan premium.',
    image: 'https://readdy.ai/api/search-image?query=modern%20clubhouse%20building%20exterior%20night%20view%20Cileungsi%20Bogor%2C%20warm%20amber%20facade%20lighting%2C%20dark%20dramatic%20sky%2C%20contemporary%20architecture%2C%20moody%20cinematic%20photography%2C%20deep%20shadows%2C%20ultra%20realistic&width=800&height=600&seq=wmm-r66-2023&orientation=landscape',
    images: [
      'https://readdy.ai/api/search-image?query=modern%20clubhouse%20building%20exterior%20night%20view%20Cileungsi%20Bogor%2C%20warm%20amber%20facade%20lighting%2C%20dark%20dramatic%20sky%2C%20contemporary%20architecture%2C%20moody%20cinematic%20photography%2C%20deep%20shadows%2C%20ultra%20realistic&width=800&height=600&seq=wmm-r66-2023&orientation=landscape',
    ],
    client: 'PT. Dwigunatama Rintisprima',
    value: 'Rp 2.290.000.000,-',
  },
  {
    id: 67,
    name: 'Marketing Gallery SGSU Avania Jakarta',
    buildingType: 'Marketing Gallery',
    location: 'Jakarta',
    year: 2023,
    status: 'Selesai',
    workPackage: 'Struktur, Arsitektur dan MEP',
    buildingArea: '700 m²',
    description: 'Pembangunan Marketing Gallery SGSU Avania Jakarta seluas 700 m², mencakup pekerjaan struktur, arsitektur, dan MEP lengkap untuk galeri pemasaran properti premium Astra Land Group.',
    image: 'https://readdy.ai/api/search-image?query=modern%20marketing%20gallery%20building%20exterior%20night%20view%20Jakarta%20Astra%20Land%2C%20warm%20amber%20facade%20lighting%2C%20dark%20dramatic%20sky%2C%20contemporary%20architecture%2C%20moody%20cinematic%20photography%2C%20deep%20shadows%2C%20ultra%20realistic&width=800&height=600&seq=wmm-r67-2023&orientation=landscape',
    images: [
      'https://readdy.ai/api/search-image?query=modern%20marketing%20gallery%20building%20exterior%20night%20view%20Jakarta%20Astra%20Land%2C%20warm%20amber%20facade%20lighting%2C%20dark%20dramatic%20sky%2C%20contemporary%20architecture%2C%20moody%20cinematic%20photography%2C%20deep%20shadows%2C%20ultra%20realistic&width=800&height=600&seq=wmm-r67-2023&orientation=landscape',
    ],
    client: 'PT Award Global Infinity (Astra Land Group)',
    value: 'Rp 12.210.000.000,-',
  },
  {
    id: 68,
    name: 'Show Unit Cluster Lazuli Suvarna Sutra Cikupa',
    buildingType: 'Perumahan Cluster',
    location: 'Cikupa, Tangerang',
    year: 2023,
    status: 'Selesai',
    workPackage: 'Struktur, Arsitektur dan MEP',
    unitCount: '3 Unit (Type 6, 7 dan 8)',
    buildingArea: '1.200 m²',
    description: 'Pembangunan 3 Rumah Show Unit Type 6, 7 dan 8 Cluster Lazuli Suvarna Sutra Cikupa seluas 1.200 m², mencakup pekerjaan struktur, arsitektur, dan MEP untuk unit percontohan hunian premium.',
    image: 'https://readdy.ai/api/search-image?query=luxury%20show%20unit%20houses%20exterior%20night%20view%20Cikupa%20Tangerang%2C%20warm%20amber%20facade%20lighting%2C%20dark%20dramatic%20sky%2C%20premium%20residential%20architecture%2C%20moody%20cinematic%20photography%2C%20deep%20shadows%2C%20ultra%20realistic&width=800&height=600&seq=wmm-r68-2023&orientation=landscape',
    images: [
      'https://readdy.ai/api/search-image?query=luxury%20show%20unit%20houses%20exterior%20night%20view%20Cikupa%20Tangerang%2C%20warm%20amber%20facade%20lighting%2C%20dark%20dramatic%20sky%2C%20premium%20residential%20architecture%2C%20moody%20cinematic%20photography%2C%20deep%20shadows%2C%20ultra%20realistic&width=800&height=600&seq=wmm-r68-2023&orientation=landscape',
    ],
    client: 'PT Lazuli Karya Sarana (Astra Land Group)',
    value: 'Rp 2.724.000.000,-',
  },
  {
    id: 69,
    name: 'Ruko Lavender Kota Podomoro Tenjo',
    buildingType: 'Ruko',
    location: 'Tenjo, Bogor',
    year: 2023,
    status: 'Selesai',
    workPackage: 'Struktur, Arsitektur dan MEP',
    unitCount: '50 Unit',
    description: 'Pembangunan Ruko Lavender sebanyak 50 unit di Kota Podomoro Tenjo, mencakup pekerjaan struktur, arsitektur, dan MEP lengkap untuk kawasan komersial modern.',
    image: 'https://readdy.ai/api/search-image?query=modern%20shophouse%20complex%2050%20units%20Lavender%20Tenjo%20Bogor%20exterior%20night%20view%2C%20warm%20amber%20facade%20lighting%2C%20dark%20dramatic%20sky%2C%20contemporary%20commercial%20architecture%2C%20moody%20cinematic%20photography%2C%20deep%20shadows%2C%20ultra%20realistic&width=800&height=600&seq=wmm-r69-2023&orientation=landscape',
    images: [
      'https://readdy.ai/api/search-image?query=modern%20shophouse%20complex%2050%20units%20Lavender%20Tenjo%20Bogor%20exterior%20night%20view%2C%20warm%20amber%20facade%20lighting%2C%20dark%20dramatic%20sky%2C%20contemporary%20commercial%20architecture%2C%20moody%20cinematic%20photography%2C%20deep%20shadows%2C%20ultra%20realistic&width=800&height=600&seq=wmm-r69-2023&orientation=landscape',
    ],
    client: 'PT. Mitra Abadi Utama (APL Group)',
    value: 'Rp 16.192.532.900,-',
  },
  {
    id: 70,
    name: 'Cluster Khaya Podomoro Golf View Cimanggis',
    buildingType: 'Perumahan Cluster',
    location: 'Cimanggis, Depok',
    year: 2023,
    status: 'Ongoing',
    workPackage: 'Struktur, Arsitektur dan MEP',
    unitCount: '12 Unit',
    description: 'Pembangunan Cluster Khaya Perumahan Podomoro Golf View Cimanggis sebanyak 12 unit, mencakup pekerjaan struktur, arsitektur, dan MEP lengkap untuk hunian premium di kawasan golf.',
    image: 'https://readdy.ai/api/search-image?query=premium%20residential%20cluster%2012%20units%20golf%20view%20Cimanggis%20Depok%20Khaya%20ongoing%20construction%2C%20modern%20houses%20concrete%20structure%2C%20warm%20amber%20work%20lights%20dusk%2C%20dark%20dramatic%20sky%2C%20professional%20architectural%20photography%2C%20deep%20shadows%2C%20cinematic%20moody%20atmosphere%2C%20ultra%20realistic&width=800&height=600&seq=wmm-r70-2023&orientation=landscape',
    images: [
      'https://readdy.ai/api/search-image?query=premium%20residential%20cluster%2012%20units%20golf%20view%20Cimanggis%20Depok%20Khaya%20ongoing%20construction%2C%20modern%20houses%20concrete%20structure%2C%20warm%20amber%20work%20lights%20dusk%2C%20dark%20dramatic%20sky%2C%20professional%20architectural%20photography%2C%20deep%20shadows%2C%20cinematic%20moody%20atmosphere%2C%20ultra%20realistic&width=800&height=600&seq=wmm-r70-2023&orientation=landscape',
    ],
    client: 'PT. Graha Tunas Selaras (APL Group)',
    value: 'Rp 5.829.332.000,-',
  },
  {
    id: 71,
    name: 'Rukan Marina Bay Manhattan PIK 2',
    buildingType: 'Ruko',
    location: 'PIK 2, Jakarta Utara',
    year: 2023,
    status: 'Selesai',
    workPackage: 'Struktur, Arsitektur dan MEP',
    unitCount: '40 Unit',
    buildingArea: '46.200 m²',
    description: 'Pembangunan Rukan Marina Bay Manhattan PIK 2 sebanyak 40 unit seluas 46.200 m², mencakup pekerjaan struktur, arsitektur, dan MEP lengkap untuk kawasan komersial premium di PIK 2.',
    image: 'https://readdy.ai/api/search-image?query=luxury%20commercial%20shophouse%20complex%2040%20units%20Marina%20Bay%20Manhattan%20PIK%202%20Jakarta%20exterior%20night%20view%2C%20warm%20amber%20facade%20lighting%2C%20dark%20dramatic%20sky%2C%20premium%20waterfront%20commercial%20architecture%2C%20moody%20cinematic%20photography%2C%20deep%20shadows%2C%20ultra%20realistic&width=800&height=600&seq=wmm-r71-2023&orientation=landscape',
    images: [
      'https://readdy.ai/api/search-image?query=luxury%20commercial%20shophouse%20complex%2040%20units%20Marina%20Bay%20Manhattan%20PIK%202%20Jakarta%20exterior%20night%20view%2C%20warm%20amber%20facade%20lighting%2C%20dark%20dramatic%20sky%2C%20premium%20waterfront%20commercial%20architecture%2C%20moody%20cinematic%20photography%2C%20deep%20shadows%2C%20ultra%20realistic&width=800&height=600&seq=wmm-r71-2023&orientation=landscape',
    ],
    client: 'PT. Sarindo Matatama',
    value: 'Rp 140.562.498.000,-',
  },

  // ─── 2024 ───
  {
    id: 72,
    name: 'Gereja Ratu Rosari Jagakarsa',
    buildingType: 'Rumah Ibadah',
    location: 'Jagakarsa, Jakarta Selatan',
    year: 2024,
    status: 'Ongoing',
    workPackage: 'Struktur, Arsitektur dan MEP',
    description: 'Pembangunan Gereja Ratu Rosari Jagakarsa Jakarta Selatan, mencakup pekerjaan struktur, arsitektur, dan MEP lengkap untuk fasilitas ibadah yang megah dan representatif.',
    image: 'https://readdy.ai/api/search-image?query=modern%20church%20building%20under%20construction%20exterior%20night%20view%20Jagakarsa%20Jakarta%20Selatan%2C%20warm%20amber%20facade%20lighting%2C%20dark%20dramatic%20sky%2C%20contemporary%20religious%20architecture%2C%20moody%20cinematic%20photography%2C%20deep%20shadows%2C%20ultra%20realistic&width=800&height=600&seq=wmm-r72-2024&orientation=landscape',
    images: [
      'https://readdy.ai/api/search-image?query=modern%20church%20building%20under%20construction%20exterior%20night%20view%20Jagakarsa%20Jakarta%20Selatan%2C%20warm%20amber%20facade%20lighting%2C%20dark%20dramatic%20sky%2C%20contemporary%20religious%20architecture%2C%20moody%20cinematic%20photography%2C%20deep%20shadows%2C%20ultra%20realistic&width=800&height=600&seq=wmm-r72-2024&orientation=landscape',
    ],
    client: 'Paroki Jagakarsa Jakarta Selatan',
    value: 'Rp 27.528.000.000,-',
  },
  {
    id: 73,
    name: 'Klenteng Jin De Yuan Ecopark PIK 2',
    buildingType: 'Rumah Ibadah',
    location: 'PIK 2, Jakarta Utara',
    year: 2024,
    status: 'Ongoing',
    workPackage: 'Struktur dan Arsitektur',
    description: 'Pembangunan Klenteng Jin De Yuan di Ecopark PIK 2, mencakup pekerjaan struktur beton bertulang dan arsitektur eksterior-interior untuk fasilitas ibadah dengan arsitektur Tionghoa yang autentik.',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20temple%20klenteng%20building%20under%20construction%20exterior%20night%20view%20PIK%202%20Jakarta%2C%20warm%20amber%20facade%20lighting%2C%20dark%20dramatic%20sky%2C%20traditional%20Chinese%20architecture%2C%20moody%20cinematic%20photography%2C%20deep%20shadows%2C%20ultra%20realistic&width=800&height=600&seq=wmm-r73-2024&orientation=landscape',
    images: [
      'https://readdy.ai/api/search-image?query=Chinese%20temple%20klenteng%20building%20under%20construction%20exterior%20night%20view%20PIK%202%20Jakarta%2C%20warm%20amber%20facade%20lighting%2C%20dark%20dramatic%20sky%2C%20traditional%20Chinese%20architecture%2C%20moody%20cinematic%20photography%2C%20deep%20shadows%2C%20ultra%20realistic&width=800&height=600&seq=wmm-r73-2024&orientation=landscape',
    ],
    client: 'PT Megah Andalan Sukses (ASG Group)',
    value: 'Rp 29.443.000.000,-',
  },
  {
    id: 74,
    name: 'Apartemen Green Sedayu Tower 2',
    buildingType: 'Apartemen',
    location: 'Jakarta',
    year: 2024,
    status: 'Ongoing',
    workPackage: 'Arsitektur',
    description: 'Pekerjaan arsitektur Apartemen Green Sedayu Tower 2, mencakup desain dan pelaksanaan arsitektur eksterior-interior apartemen premium dengan konsep green building modern.',
    image: 'https://readdy.ai/api/search-image?query=luxury%20green%20apartment%20tower%202%20under%20construction%20exterior%20night%20view%20Jakarta%2C%20warm%20amber%20facade%20lighting%2C%20dark%20dramatic%20sky%2C%20premium%20high%20rise%20green%20architecture%2C%20moody%20cinematic%20photography%2C%20deep%20shadows%2C%20ultra%20realistic&width=800&height=600&seq=wmm-r74-2024&orientation=landscape',
    images: [
      'https://readdy.ai/api/search-image?query=luxury%20green%20apartment%20tower%202%20under%20construction%20exterior%20night%20view%20Jakarta%2C%20warm%20amber%20facade%20lighting%2C%20dark%20dramatic%20sky%2C%20premium%20high%20rise%20green%20architecture%2C%20moody%20cinematic%20photography%2C%20deep%20shadows%2C%20ultra%20realistic&width=800&height=600&seq=wmm-r74-2024&orientation=landscape',
    ],
    client: 'PT Panorama Bangun Lestari (ASG Group)',
    value: 'Rp 35.950.000.000,-',
  },

  // ─── 2026 ───
  {
    id: 75,
    name: 'Rumah Sakit Charitas Kenten Palembang',
    buildingType: 'Rumah Sakit',
    location: 'Palembang, Sumatera Selatan',
    year: 2026,
    status: 'Ongoing',
    workPackage: 'Struktur, Arsitektur dan MEP',
    floors: '5 Lantai',
    buildingArea: '7.170 m²',
    description: 'Pembangunan Rumah Sakit Charitas Kenten Palembang 5 lantai seluas 7.170 m², mencakup pekerjaan struktur, arsitektur, dan MEP lengkap untuk fasilitas kesehatan modern yang representatif.',
    image: 'https://readdy.ai/api/search-image?query=modern%20hospital%20building%205%20floors%20under%20construction%20exterior%20night%20view%20Palembang%2C%20warm%20amber%20facade%20lighting%2C%20dark%20dramatic%20sky%2C%20contemporary%20medical%20architecture%2C%20moody%20cinematic%20photography%2C%20deep%20shadows%2C%20ultra%20realistic&width=800&height=600&seq=wmm-r75-2026&orientation=landscape',
    images: [
      'https://readdy.ai/api/search-image?query=modern%20hospital%20building%205%20floors%20under%20construction%20exterior%20night%20view%20Palembang%2C%20warm%20amber%20facade%20lighting%2C%20dark%20dramatic%20sky%2C%20contemporary%20medical%20architecture%2C%20moody%20cinematic%20photography%2C%20deep%20shadows%2C%20ultra%20realistic&width=800&height=600&seq=wmm-r75-2026&orientation=landscape',
    ],
    client: 'Yayasan Rumah Sakit Charitas',
    value: 'Rp 76.600.000.000,-',
  },
  {
    id: 76,
    name: 'Ruko La Promenade Astakona Karawang',
    buildingType: 'Ruko',
    location: 'Karawang, Jawa Barat',
    year: 2026,
    status: 'Ongoing',
    workPackage: 'Struktur, Arsitektur dan MEP',
    unitCount: '39 Unit',
    description: 'Pembangunan Ruko La Promenade sebanyak 39 unit di Astakona Karawang, mencakup pekerjaan struktur, arsitektur, dan MEP lengkap untuk kawasan komersial modern.',
    image: 'https://readdy.ai/api/search-image?query=modern%20shophouse%20complex%2039%20units%20La%20Promenade%20Astakona%20Karawang%20exterior%20night%20view%2C%20warm%20amber%20facade%20lighting%2C%20dark%20dramatic%20sky%2C%20contemporary%20commercial%20architecture%2C%20moody%20cinematic%20photography%2C%20deep%20shadows%2C%20ultra%20realistic&width=800&height=600&seq=wmm-r76-2026&orientation=landscape',
    images: [
      'https://readdy.ai/api/search-image?query=modern%20shophouse%20complex%2039%20units%20La%20Promenade%20Astakona%20Karawang%20exterior%20night%20view%2C%20warm%20amber%20facade%20lighting%2C%20dark%20dramatic%20sky%2C%20contemporary%20commercial%20architecture%2C%20moody%20cinematic%20photography%2C%20deep%20shadows%2C%20ultra%20realistic&width=800&height=600&seq=wmm-r76-2026&orientation=landscape',
    ],
    client: 'PT Astakona Megatama (APL Group)',
    value: 'Rp 32.800.000.000,-',
  },
  {
    id: 77,
    name: 'Hotel Hilton Garden Inn Batam',
    buildingType: 'Hotel',
    location: 'Batam, Kepulauan Riau',
    year: 2026,
    status: 'Ongoing',
    workPackage: 'Struktur, Arsitektur dan Plumbing',
    floors: '2 Basement + 10 Lantai',
    buildingArea: '19.860 m²',
    description: 'Pembangunan Hotel Hilton Garden Inn Batam 2 basement + 10 lantai seluas 19.860 m², mencakup pekerjaan struktur, arsitektur, dan plumbing untuk hotel bintang empat internasional di Batam.',
    image: 'https://readdy.ai/api/search-image?query=luxury%20international%20hotel%20Hilton%20Garden%20Inn%2010%20floors%20basement%20under%20construction%20exterior%20night%20view%20Batam%2C%20warm%20amber%20facade%20lighting%2C%20dark%20dramatic%20sky%2C%20premium%20hotel%20architecture%2C%20moody%20cinematic%20photography%2C%20deep%20shadows%2C%20ultra%20realistic&width=800&height=600&seq=wmm-r77-2026&orientation=landscape',
    images: [
      'https://readdy.ai/api/search-image?query=luxury%20international%20hotel%20Hilton%20Garden%20Inn%2010%20floors%20basement%20under%20construction%20exterior%20night%20view%20Batam%2C%20warm%20amber%20facade%20lighting%2C%20dark%20dramatic%20sky%2C%20premium%20hotel%20architecture%2C%20moody%20cinematic%20photography%2C%20deep%20shadows%2C%20ultra%20realistic&width=800&height=600&seq=wmm-r77-2026&orientation=landscape',
    ],
    client: 'PT Sabang Raya Investama',
    value: 'Rp 137.738.000.000,-',
  },
];

// Ongoing projects for featured section on homepage (real ongoing projects)
export const ongoingProjects: Project[] = projects.filter((p) => p.status === 'Ongoing');

export const featuredProjects = ongoingProjects;
